export const translations = {
  it: {
    // Header
    language: 'Lingua',
    round: 'Round',
    combat: 'Combattimento',
    
    // Home Screen
    selectMode: 'Seleziona Modalità',
    selectModeDesc: 'Scegli la modalità adatta a te e inizia a tracciare il combattimento',
    personalTracking: 'Sono un player',
    personalHubTitle: 'Hub del Player',
    personalTrackingDesc: 'Crea i tuoi personaggi, gestisci PF e iniziativa e combatti da solo o con i tuoi party',
    masterMode: 'Modalità Master',
    masterModeDesc: 'Crea una lobby multiplayer',
    masterModeDescLong: 'Sei il Dungeon Master? Crea una lobby, condividi il codice con i giocatori e gestisci iniziativa, HP e turni per tutti in tempo reale.',
    masterOffline: 'Sono un master',
    masterOfflineDesc: 'Gestisci i combattimenti al tavolo: iniziativa, turni e PF. Prepara la sessione con NPC e appunti, poi entra in battaglia.',
    masterHubTitle: 'Hub del Master',
    masterHubDesc: 'Scegli come prepararti o entrare in battaglia.',
    sessionPrep: 'Preparazione alla sessione',
    sessionPrepDesc: 'Organizza sessioni con nome: appunti, timeline e luoghi con incontri, dialoghi, oggetti, personaggi e missioni per ogni luogo.',
    sessionPrepDescLong: 'Sessioni con nome: appunti, timeline e luoghi (incontri, dialoghi, oggetti, missioni). Salva e riapri quando serve.',
    sessionPrepEditorDesc: 'In alto: appunti e timeline. Sotto: luoghi. In ogni luogo aggiungi incontri, dialoghi, oggetti, personaggi, missioni e checklist. Nome sessione + Salva.',
    noSavedSessions: 'Nessuna sessione salvata. Clicca "Nuova sessione" per crearne una (nome, appunti, luoghi). Salva per recuperarla dopo.',
    noPlaces: 'Nessun luogo. Clicca "Aggiungi luogo" e compila incontri, dialoghi, oggetti, personaggi e missioni per quel posto.',
    coinPouchTitle: 'Borsa monete',
    coinPouchButton: 'Portafoglio',
    coinPouchCurrent: 'Saldo attuale',
    coinPouchTotalCopper: 'Totale in rame',
    coinPouchAdd: 'Aggiungi monete',
    coinPouchAddButton: 'Aggiungi',
    coinPouchSpend: 'Spendi monete',
    coinPouchSpendEquivalent: 'Equivalente',
    coinPouchSpendButton: 'Spendi',
    coinPouchInsufficient: 'Saldo insufficiente.',
    coinPouchEnterAmount: 'Inserisci l\'importo da spendere.',
    coinPouchSpent: 'Spesa applicata.',
    coinPlatino: 'MP',
    coinOro: 'MO',
    coinElettro: 'ME',
    coinArgento: 'MA',
    coinRame: 'MR',
    coinPouchEmptyAll: 'Svuota tutto',
    coinPouchEmptyConfirmTitle: 'Svuotare la borsa?',
    coinPouchEmptyConfirmDesc: 'Saldo azzerato. Azione irreversibile.',
    coinPouchEmptyConfirmButton: 'Svuota tutto',
    manageNpcEnemies: 'Gestisci NPC/Nemici',
    manageNpcDesc: 'Crea e modifica preset di NPC, nemici e compagni: PF, CA, iniziativa e note per usarli rapidamente in battaglia.',
    manageNpcDescLong: 'Preset per NPC, nemici e compagni: nome, PF, CA, bonus iniziativa, velocità, note. Aggiungi in battaglia con un clic.',
    npcPresetsEmpty: 'Nessun preset. Clicca "Nuovo preset": nome, PF, CA, bonus iniziativa, tipo e note. Poi usali in battaglia.',
    joinLobby: 'Entra in Lobby',
    joinLobbyDesc: 'Unisciti a una lobby esistente',
    joinLobbyDescLong: 'Inserisci il codice del Master per entrare e seguire il combattimento in tempo reale.',
    multiplayer: 'Multiplayer',
    multiplayerBeta: 'Beta',
    inDevelopment: 'In Sviluppo',
    comingSoon: 'In arrivo',
    installAppTitle: 'Installa il sito come un\'app',
    installAppStep1: 'Chrome/Edge: icona (⊕) in barra indirizzi o Menu → Installa CoCo.',
    installAppStep2: 'Safari (Mac): File → Aggiungi a Dock.',
    installAppStep3: 'Firefox: menu (≡) → Installa.',
    installAppStepIos: 'iPhone/iPad: Safari → Condividi → Aggiungi a Home.',
    installAppStepAndroid: 'Android: Chrome → Menu (⋮) → Aggiungi a Home / Installa app.',
    installAppDontShow: 'Non mostrare più',
    installAppNotNow: 'Non ora',
    installAppLetsGo: 'Iniziamo!',
    installAppHint: 'Installa CoCo come app',
    multiplayer: 'Multiplayer',
    multiplayerDesc: 'Crea una lobby o unisciti con un codice per giocare online',
    charactersHomeDesc: 'Crea o elimina i tuoi personaggi',
    ariaThemeAccent: 'Tema e accento',
    themeLabel: 'Tema',
    accentLabel: 'Accento',
    themeLight: 'Chiaro',
    themeDark: 'Scuro',
    close: 'Chiudi',
    remove: 'Rimuovi',
    unpin: 'Sblocca',
    pinInitiative: 'Blocca in alto',
    supportKofi: 'Supporta il progetto su Ko-fi',
    kofiHideBanner: 'Nascondi banner',
    kofiShowBanner: 'Mostra supporto Ko-fi',
    footerSupportText: 'CoCo è senza pubblicità ed è gratis (ma non per me 😔) quindi se vuoi:',
    footerMadeWithLove: 'Made with love in 2026 by TakaDev 💛',
    privacyPolicy: 'Privacy',
    privacyTitle: 'Informativa sulla privacy',
    privacyMetaDescription: 'Informativa sulla privacy di CoCo (Combat Companion): dati trattati, conservazione locale, multiplayer e servizi di terze parti.',
    privacyLastUpdated: 'Ultimo aggiornamento: 28 giugno 2026',
    privacyIntro: 'CoCo (Combat Companion) è una web app per la gestione del combattimento in D&D 5e, disponibile su combatco.app e come app installabile (PWA/TWA). Questa informativa descrive come trattiamo i dati personali in conformità al Regolamento UE 2016/679 (GDPR).',
    backToHome: 'Torna alla home',
    privacySections: [
      {
        title: '1. Titolare del trattamento',
        body: 'Il titolare del trattamento è TakaDev, sviluppatore di CoCo (Combat Companion).\nPer richieste relative alla privacy puoi contattarci tramite il sito https://combatco.app.',
      },
      {
        title: '2. Dati che trattiamo',
        body: 'CoCo non richiede registrazione né crea un account utente. I dati che possono essere trattati includono:\n• Dati inseriti volontariamente nell\'app (nomi personaggi, note di gioco, dati di combattimento, preparazione sessione), salvati principalmente sul dispositivo.\n• Dati tecnici anonimi o aggregati (es. visite pagina) tramite Vercel Analytics.\n• In modalità multiplayer: identificatori di sessione PeerJS e dati di gioco scambiati in tempo reale tra i partecipanti connessi.\n• Preferenze dell\'app (lingua, tema, accento) salvate localmente nel browser.',
      },
      {
        title: '3. Finalità e base giuridica',
        body: 'Trattiamo i dati per:\n• Fornire le funzionalità dell\'app (combattimento, personaggi, preparazione sessione, multiplayer).\n• Migliorare stabilità e usabilità del servizio.\n• Rispettare obblighi di legge.\nLa base giuridica è l\'esecuzione del servizio richiesto (art. 6.1.b GDPR), il legittimo interesse a migliorare il prodotto (art. 6.1.f GDPR) e, ove applicabile, il consenso per servizi opzionali di terze parti.',
      },
      {
        title: '4. Conservazione sul dispositivo',
        body: 'La maggior parte dei dati di gioco è memorizzata in localStorage sul tuo dispositivo. Puoi eliminarli in qualsiasi momento cancellando i dati del sito/app dal browser o disinstallando l\'applicazione. Noi non conserviamo su server propri i contenuti delle tue partite in modalità offline.',
      },
      {
        title: '5. Modalità multiplayer',
        body: 'La funzione multiplayer utilizza PeerJS per connessioni peer-to-peer tra Master e giocatori. I dati di gioco vengono trasmessi direttamente tra i dispositivi collegati; non vengono archiviati permanentemente su un server CoCo. I server di segnalazione PeerJS possono elaborare metadati di connessione necessari a stabilire la comunicazione.',
      },
      {
        title: '6. Servizi di terze parti',
        body: 'L\'app può integrare o collegarsi a servizi esterni, tra cui:\n• Vercel Analytics (statistiche di utilizzo anonime/aggregate)\n• Google Fonts (caricamento font)\n• Ko-fi (widget opzionale di supporto al progetto)\n• PeerJS (multiplayer)\n• Google Play (distribuzione app Android TWA)\nCiascun fornitore tratta i dati secondo la propria informativa privacy.',
      },
      {
        title: '7. Diritti dell\'interessato',
        body: 'Hai diritto di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità dei dati, ove applicabile. Puoi revocare il consenso in qualsiasi momento senza pregiudicare la liceità del trattamento precedente. Hai inoltre diritto di proporre reclamo all\'Autorità Garante per la protezione dei dati personali (www.garanteprivacy.it).',
      },
      {
        title: '8. Minori',
        body: 'CoCo è pensata per giocatori di giochi di ruolo; non raccogliamo consapevolmente dati personali di minori di 16 anni senza il consenso di chi esercita la responsabilità genitoriale.',
      },
      {
        title: '9. Modifiche',
        body: 'Potremmo aggiornare questa informativa per riflettere cambiamenti legali o funzionali dell\'app. La data di ultimo aggiornamento è indicata in cima alla pagina.',
      },
    ],
    homeAppIntro: 'CoCo è un combat tracker per D&D 5e: gestisci iniziativa, turni, punti ferita (HP), status, note e preparazione sessione in modo rapido, ordinato e ottimizzato per Master e Player.',
    howItWorksCta: 'Come funziona CoCo?',
    guideShort: 'Guida',
    howItWorksTitle: 'Come funziona CoCo',
    howItWorksIntro: 'Guida rapida a CoCo, app per iniziativa D&D 5e e gestione combattimento: scopri come usare tracker turni, HP, status e strumenti Master in modo semplice.',
    howItWorksInitiativeTitle: '1) Tracker iniziativa D&D 5e',
    howItWorksInitiativeBody: 'Monitora ordine di iniziativa, turno attivo e round del combattimento D&D 5e in pochi tocchi. Perfetto per tenere il ritmo al tavolo senza perdere informazioni.',
    howItWorksHpTitle: '2) Gestione HP, status e risorse',
    howItWorksHpBody: 'Aggiorna rapidamente punti ferita (HP), KO, condizioni, slot incantesimo e risorse turno per personaggi e NPC. Tutto in una vista chiara per il combat tracking.',
    howItWorksPrepTitle: '3) Tool Master per preparazione sessione',
    howItWorksPrepBody: 'Organizza luoghi, note, personaggi, dialoghi, oggetti e missioni prima della sessione. In gioco hai tutto pronto in un unico strumento per Dungeon Master.',
    enterBattleDesc: 'Lobby e combattimento in tempo reale',
    inBattle: 'in battaglia',
    nextRound: 'Prossimo round',
    combatants: 'combattenti',
    addPreset: 'Nuovo preset',
    notes: 'Note',
    notesPlaceholder: 'Tratti, abilità, descrizione...',
    sessionPrepPlaces: 'Luoghi',
    addPlace: 'Aggiungi luogo',
    pasteFullCode: 'Incolla il link o il codice ricevuto dal Master',
    invalidCode: 'Codice lobby non valido',
    heart: 'Cuore',
    toggleKo: 'Toggle KO',
    characterFormDesc: 'Modulo personaggio',
    combatantFormDesc: 'Modulo combattente',
    nameExample: 'Ad esempio: {name}',
    sessionPrepNotes: 'Appunti',
    sessionPrepTimeline: 'Timeline',
    addNote: 'Aggiungi appunto...',
    addEvent: 'Aggiungi evento...',
    sessionPrepDialogues: 'Dialoghi',
    sessionPrepEncounters: 'Incontri',
    sessionPrepObjects: 'Oggetti',
    sessionPrepCharacters: 'Personaggi',
    sessionPrepMissions: 'Missioni',
    addDialogue: 'Aggiungi dialogo...',
    addEncounter: 'Aggiungi incontro...',
    addObject: 'Aggiungi oggetto...',
    addMission: 'Aggiungi missione...',
    addChecklistItem: 'Aggiungi voce...',
    checklist: 'Checklist',
    empty: 'Vuoto',
    newSession: 'Nuova sessione',
    newPlace: 'Nuovo luogo',
    savedSessions: 'Sessioni salvate',
    sessionNamePlaceholder: 'Nome sessione',
    sessionUnnamed: 'Sessione senza nome',
    unnamedPlace: 'Senza nome',
    open: 'Apri',
    saved: 'Salvato',
    deleted: 'Eliminato',
    deleteSessionConfirm: 'Eliminare questa sessione?',
    deletePresetConfirm: 'Eliminare questo preset?',
    addAll: 'Aggiungi tutti',
    selectCharacters: 'Seleziona Personaggi',
    selectMultiple: 'Puoi selezionare più personaggi',
    selectedCount: 'Selezionati',
    clearSelection: 'Deseleziona tutti',
    noCharacterSelected: 'Nessun personaggio selezionato',
    charactersAdded: 'personaggi aggiunti',
    
    // Characters
    noCharacters: 'Nessun personaggio',
    createFirstCharacter: 'Crea il primo personaggio',
    addCharacter: 'Nuovo Personaggio',
    addCharacterFromListDesc: 'Scegli un personaggio da Personaggi',
    editCharacter: 'Modifica Personaggio',
    characterSaved: 'Personaggio salvato',
    characterUpdated: 'Personaggio aggiornato',
    characterDeleted: 'Personaggio eliminato',
    characterDuplicated: 'Personaggio duplicato',
    addedToCombat: 'aggiunto al combattimento',
    alreadyInBattle: 'già in battaglia',
    goToCombat: 'Vai al Combattimento',
    enterBattle: 'Entra in Battaglia',
    fightWith: 'Combatti con',
    selected: 'selezionati',
    deselect: 'Deseleziona',
    selectAll: 'Seleziona tutto',
    charactersSelected: 'personaggi selezionati',
    xp: 'XP',
    xpTotal: 'XP totale',
    addXp: 'Aggiungi XP guadagnata',
    addXpAction: 'Aggiungi XP',
    editTotalXp: 'Modifica XP totale',
    xpGained: 'XP aggiunta',
    xpTotalUpdated: 'XP totale aggiornata',
    
    // Tutorials
    saveTutorialTitle: 'Salva i personaggi',
    saveTutorialDesc: 'Header: importa/esporta personaggi in JSON.',
    battleTutorialTitle: 'Entra in battaglia',
    battleTutorialDesc: 'Seleziona i personaggi (caselle) e clicca "Combatti con X selezionati".',
    dontShowAgain: 'Non mostrare più',
    tutorialsDisabled: 'Tutorial disabilitati',
    tutorialTitle: 'Tutorial',
    tutorialNext: 'Avanti',
    tutorialStart: 'Inizia',
    tutorialSkip: 'Salta',
    tutorialPersonalWelcomeTitle: 'Tracking personale',
    tutorialPersonalWelcomeContent: 'Gestisci personaggi e combattimenti in locale, senza connessione.',
    tutorialPersonal1Title: '1. Personaggi',
    tutorialPersonal1Content: '\'Nuovo Personaggio\' per creare e salvare. Riutilizzabili in seguito.',
    tutorialPersonal2Title: '2. Combattimento',
    tutorialPersonal2Content: '\'Combattimento\' su un personaggio per aggiungerlo. Puoi aggiungerne più di uno.',
    tutorialPersonal3Title: '3. Turni',
    tutorialPersonal3Content: 'Pulsanti per PF, status e turno successivo. Iniziativa tracciata in automatico.',
    tutorialMasterWelcomeTitle: 'Master offline',
    tutorialMasterWelcomeContent: 'Combattimento con giocatori, NPC, nemici e compagni.',
    tutorialMaster1Title: '1. Tipi',
    tutorialMaster1Content: 'Giocatori (bianco), NPC alleati (blu), Nemici (rosso), Famigli (verde).',
    tutorialMaster2Title: '2. Aggiungi',
    tutorialMaster2Content: '\'Aggiungi\' → scegli tipo. Puoi nascondere PF/CA di NPC e nemici.',
    tutorialMaster3Title: '3. Turni',
    tutorialMaster3Content: 'Iniziativa in alto. \'Prossimo Turno\' per avanzare. Tiri salvezza morte per KO.',
    
    // Temp HP
    tempHp: 'PF Temp',
    tempHpShort: 'Temp',
    addTempHp: 'Aggiungi PF Temp',
    
    // Master Lobby
    createOrResume: 'Crea o Riprendi Lobby',
    createNewLobby: 'Crea Nuova Lobby',
    resumeLobby: 'Riprendi Lobby',
    lobbyCode: 'Codice Lobby',
    lobbyShareHint: 'Condividi link o QR per far entrare i giocatori',
    codeCopied: 'Codice copiato',
    linkCopied: 'Link copiato',
    copyLink: 'Copia Link',
    connectedPlayers: 'Giocatori Connessi',
    waitingForPlayers: 'In attesa di giocatori...',
    closeLobby: 'Chiudi Lobby',
    lobbyClosed: 'Lobby chiusa',
    lobbyResumed: 'Lobby ripresa',
    fullCodeCopied: 'Il codice completo include l\'ID del Master',
    showQR: 'Mostra QR Code',
    hideQR: 'Nascondi QR',
    rejoinLobbySavedMaster: 'Lobby Master salvata',
    rejoinLobbySavedPlayer: 'Lobby Giocatore salvata',
    rejoinLobbyButton: 'Rientra',
    dismissSavedLobby: 'Chiudi lobby',
    
    // Player status at a glance
    playerStatus: 'Stato Giocatori',
    healthy: 'In salute',
    injured: 'Ferito',
    critical: 'Critico',
    down: 'KO',
    addNPC: 'Aggiungi NPC/Mostro',
    addQuickCombatant: 'Aggiungi Rapido',
    more: 'altri',
    
    // Combatant types
    player: 'Giocatore',
    npcAlly: 'NPC Alleato',
    enemyType: 'Nemico',
    companion: 'Famiglio',
    combatantType: 'Tipo di Combattente',
    concentration: 'Concentrazione',
    concentrationCheckTitle: 'Tiro salvezza concentrazione',
    concentrationCheckDesc: 'd20 Costituzione: 10+ successo, sotto 10 fallimento.',
    concentrationSuccessBtn: 'Successo',
    concentrationFailureBtn: 'Fallimento',
    concentrationSuccess: 'Concentrazione mantenuta',
    concentrationLost: 'Concentrazione persa',
    advDis: 'Vantaggio/Svantaggio',
    advantage: 'Vantaggio',
    disadvantage: 'Svantaggio',
    normal: 'Normale',
    action: 'Azione',
    actionShort: 'Az.',
    bonusAction: 'Azione bonus',
    bonusActionShort: 'Az. bonus',
    reaction: 'Reazione',
    reactionShort: 'Reaz.',
    advantageShort: 'Vant.',
    disadvantageShort: 'Svant.',
    actionTooltip: 'Azione (reset al prossimo turno)',
    bonusActionTooltip: 'Azione bonus (reset al prossimo turno)',
    reactionTooltip: 'Reazione (reset al prossimo round)',
    dash: 'Scatto',
    
    // Enemy/Ally
    enemy: 'Nemico',
    ally: 'Alleato',
    isEnemy: 'È un nemico',
    hpVisible: 'PF visibili ai giocatori',
    hpHidden: 'PF nascosti',
    acVisible: 'CA visibile',
    
    // Join Lobby
    enterLobbyCode: 'Inserisci Codice Lobby',
    yourName: 'Il tuo Nome',
    continue: 'Continua',
    selectCharacter: 'Seleziona Personaggio',
    noSavedCharacters: 'Nessun personaggio salvato',
    joinWithoutCharacter: 'Entra senza personaggio',
    connected: 'Connesso!',
    waitingForMaster: 'In attesa del Master...',
    connecting: 'Connessione in corso...',
    leaveLobby: 'Esci dalla Lobby',
    enterWithQRCode: 'Entra con QR code',
    orEnterManually: 'Oppure inserisci il codice sotto',
    scanQRCode: 'Scansiona il QR code',
    scanQRCodeDesc: 'Inquadra il QR del Master per inserire il codice.',
    qrNoCamera: 'Nessuna fotocamera disponibile',
    qrCameraError: 'Impossibile avviare la fotocamera',
    qrStartingCamera: 'Avvio fotocamera...',
    qrCodeScanned: 'Codice letto!',
    viewBattlefield: 'Vai al campo di battaglia',
    yourCharacters: 'I tuoi Personaggi',
    you: 'Tu',
    
    // Combat
    initiative: 'Iniziativa',
    initiativeOrder: 'Ordine di Iniziativa',
    hp: 'PF',
    ac: 'CA',
    currentTurn: 'Turno attivo',
    shortRest: 'Riposo breve',
    longRest: 'Riposo lungo',
    shortRestShort: 'Rip. breve',
    longRestShort: 'Rip. lungo',
    shortRestAll: 'Riposo breve (tutti)',
    longRestAll: 'Riposo lungo (tutti)',
    shortRestDone: 'Riposo breve fatto',
    longRestDone: 'Riposo lungo fatto',
    shortRestAllDone: 'Riposo breve fatto (tutti)',
    longRestAllDone: 'Riposo lungo fatto (tutti)',
    shortRestTitle: 'Riposo breve – Dadi vita',
    shortRestNumDice: 'Numero dadi',
    shortRestDieType: 'Tipo dado',
    shortRestRoll: 'Tira',
    shortRestApply: 'Applica',
    shortRestResult: 'Risultato',
    shortRestRecovered: 'PF recuperati',
    shortRestZeroDice: '0 = riposo senza spendere dadi vita',
    shortRestLog: 'ha fatto riposo breve',
    longRestLog: 'ha fatto riposo lungo',
    ko: 'KO',
    
    // Actions
    nextTurn: 'Prossimo Turno',
    addCombatant: 'Aggiungi',
    reset: 'Reset',
    exportJson: 'Esporta JSON',
    importJson: 'Importa JSON',
    dataMenu: 'Dati',
    backupComplete: 'Backup completo',
    backupCompleteDesc: 'Personaggi + combattimento + impostazioni',
    restoreBackup: 'Ripristina backup',
    restoreBackupDesc: 'Importa backup completo (sostituisce tutto)',
    exportCharactersOnly: 'Solo personaggi (esporta)',
    importCharactersOnly: 'Solo personaggi (importa)',
    dataMenuCharactersSection: 'Solo personaggi',
    menu: 'Menu',
    status: 'Status',
    modify: 'Modifica',
    duplicate: 'Duplica',
    
    // Combatant card
    damage: 'Danno',
    heal: 'Cura',
    customAmount: 'Valore',
    apply: 'Applica',
    edit: 'Modifica',
    delete: 'Elimina',
    
    // Death Saves
    deathSaves: 'Tiri Salvezza su Morte',
    success: 'Successo',
    failure: 'Fallimento',
    stabilized: 'Stabilizzato!',
    backTo1HP: 'Torna a 1 PF',
    dead: 'Morto',
    
    // Add/Edit modal
    addCombatantTitle: 'Aggiungi Combattente',
    editCombatantTitle: 'Modifica Combattente',
    name: 'Nome',
    namePlaceholder: 'Es. Goblin, Guerriero...',
    maxHp: 'PF Massimi',
    currentHp: 'PF Attuali',
    initiativeValue: 'Iniziativa',
    initiativeBonus: 'Bonus iniziativa',
    speed: 'Velocità',
    speedMovement: 'Velocità di movimento',
    speedUnit: 'm/s',
    hitDice: 'Dadi vita',
    hitDiceTotal: 'Numero dadi',
    hitDiceSides: 'Tipo dado',
    hitDiceAvailable: 'Dadi disponibili',
    spellSlots: 'Slot incantesimo',
    statuses: 'Status',
    addStatus: 'Aggiungi Status',
    statusName: 'Nome Status',
    statusDuration: 'Durata (round)',
    dotLabel: 'Danno per turno',
    dotDamage: 'Danno',
    dotDuration: 'Durata (turni)',
    optional: 'opzionale',
    famiglio: 'Famiglio',
    famiglioOf: 'Famiglio di',
    famiglioOfPlaceholder: 'Seleziona personaggio',
    searchCharacter: 'Cerca personaggio...',
    save: 'Salva',
    cancel: 'Annulla',
    
    // Status presets
    statusPresets: [
      'Avvelenato', 'Stordito', 'Accecato', 'Paralizzato', 
      'Bruciato', 'Congelato', 'Affascinato', 'Spaventato',
      'Prono', 'Trattenuto', 'Invisibile', 'Incapacitato'
    ],
    
    // Messages
    combatantAdded: 'Combattente aggiunto',
    combatantUpdated: 'Combattente aggiornato',
    combatantDeleted: 'Combattente eliminato',
    combatReset: 'Combattimento resettato',
    dataExported: 'Dati esportati',
    dataImported: 'Dati importati',
    importError: 'Errore nell\'importazione',
    turnChanged: 'Turno di',
    quickInitiative: 'Iniziativa rapida',
    initiativeRolled: 'Iniziativa tirata',
    quickInitiativePromptDesc: "Tira l'iniziativa per:",
    quickInitiativeForAll: 'Per tutti',
    quickInitiativeNpcEnemiesOnly: 'Solo NPC e Nemici',
    dotApplied: 'DoT applicato:',
    damagePoints: 'danni',
    statusExpired: 'Status scaduto:',
    charactersExported: 'personaggi esportati',
    charactersImported: 'personaggi importati',
    noCharactersToExport: 'Nessun personaggio da esportare',
    
    // Confirm
    confirmReset: 'Resettare il combattimento?',
    confirmDelete: 'Eliminare questo combattente?',
    yes: 'Sì',
    no: 'No',
    
    // Empty state
    noCombatants: 'Nessun combattente',
    addFirst: 'Aggiungi un combattente per iniziare',
    
    // Misc
    characters: 'Personaggi',
    back: 'Indietro',
    backToHome: 'Torna alla home',
    eventHistory: 'Cronologia',
    collapseAll: 'Comprimi tutti',
    expandAll: 'Espandi tutti',
    noEvents: 'Nessun evento registrato',
    battleNotes: 'Note di battaglia',
    battleNotesPlaceholder: 'Appunti, obiettivi, reminder...',
    npcPresetsTitle: 'Preset NPC',
    npcPresetNew: 'Nuovo preset',
    addToBattleShort: 'In battaglia',
    npcPresetSaved: 'Preset salvato',
    saveToPresets: 'Salva nei preset',
    presetsList: 'Preset salvati',
    saveFromBattle: 'Salva come preset da battaglia',
    saveAsPresetShort: 'Salva preset',
    clearHistory: 'Cancella cronologia',
    clear: 'Azzera',
    historyCleared: 'Cronologia cancellata',
    turnOf: 'Turno di',
    tookDamage: 'ha subito',
    damageText: 'danni',
    wasHealed: 'è stato curato di',
    hpText: 'PF',
    gainedStatus: 'è ora',
    lostStatus: 'non è più',
    wasAdded: 'è entrato in combattimento',
    wasRemoved: 'è stato rimosso',
    stabilizedText: 'si è stabilizzato',
    diedText: 'è morto',
    koText: 'è andato KO',
    revivedText: 'è stato rianimato',
    tempHpGained: 'ha ottenuto',
    tempHpText: 'PF temporanei',
    deathSaveSuccess: 'ha superato un tiro salvezza morte',
    deathSaveFailure: 'ha fallito un tiro salvezza morte',
    statusDictionary: {
      'Accecato': { name: 'Accecato', description: 'Non vede. Svantaggio attacchi; attacchi contro hanno vantaggio.' },
      'Affascinato': { name: 'Affascinato', description: 'Non può attaccare né bersagliare chi lo ha affascinato.' },
      'Afferrato': { name: 'Afferrato', description: 'Velocità 0, niente bonus velocità.' },
      'Assordato': { name: 'Assordato', description: 'Non sente. Fallisce prove che richiedono udito.' },
      'Avvelenato': { name: 'Avvelenato', description: 'Svantaggio ad attacchi e prove.' },
      'Concentrazione': { name: 'Concentrazione', description: 'Mantiene incantesimo; danno richiede TS concentrazione.' },
      'Esausto': { name: 'Esausto', description: 'Livelli 1-6: da svantaggio prove a morte.' },
      'Impaurito': { name: 'Impaurito', description: 'Svantaggio se vede la fonte; non può avvicinarsi.' },
      'Incapacitato': { name: 'Incapacitato', description: 'Niente azioni né reazioni.' },
      'Invisibile': { name: 'Invisibile', description: 'Non visibile. Svantaggio attacchi contro; vantaggio suoi attacchi.' },
      'Paralizzato': { name: 'Paralizzato', description: 'Incapacitato, vel 0. Fallisce TS For/Des. Mischia: vantaggio, critico a 1,5 m.' },
      'Pietrificato': { name: 'Pietrificato', description: 'Pietra. Incapacitato, peso x10.' },
      'Privo di sensi': { name: 'Privo di sensi', description: 'Incapacitato, a terra. Mischia 1,5 m: critico.' },
      'Prono': { name: 'Prono', description: 'A terra. Svantaggio a distanza; vantaggio mischia 1,5 m.' },
      'Rallentato': { name: 'Rallentato', description: 'Velocità metà, -2 CA. Un\'azione o bonus per turno, niente reazione.' },
      'Sanguinante': { name: 'Sanguinante', description: 'Danno ogni turno fino a cura/stabilizzazione.' },
      'Sorpreso': { name: 'Sorpreso', description: 'Primo round: non si muove, non agisce, niente reazioni.' },
      'Spaventato': { name: 'Spaventato', description: 'Svantaggio se vede la fonte; non può avvicinarsi.' },
      'Stordito': { name: 'Stordito', description: 'Incapacitato, vel 0. Fallisce TS For/Des. Non parla.' },
      'Trattenuto': { name: 'Trattenuto', description: 'Vel 0. Svantaggio attacchi; attacchi contro vantaggio; svantaggio TS Des.' },
      'Benedizione': { name: 'Benedizione', description: '+1d4 a un attacco o TS (tira dopo il dado).' },
      'Eroismo': { name: 'Eroismo', description: 'Immune paura. PF temp ogni turno.' },
      'Fretta': { name: 'Fretta', description: 'Velocità x2, +2 CA, vantaggio TS Des, azione extra (limitata).' },
      'Guidare': { name: 'Guidare', description: '+1d4 a una prova (tira dopo il dado).' },
      'Protezione': { name: 'Protezione', description: 'Reazione: svantaggio attacco su alleato adiacente o +1d4 TS alleato.' },
      'Rigenerazione': { name: 'Rigenerazione', description: 'PF recuperati ogni turno (es. 10).' },
      'Scudo': { name: 'Scudo', description: 'Reazione: +5 CA contro un attacco fino al prossimo turno.' },
      'Volare': { name: 'Volare', description: 'Può volare. Velocità di volo da effetto.' },
      'Altro...': { name: 'Altro...', description: 'Status personalizzato: nome e durata.' },
      'Esausto 1': { name: 'Esausto 1', description: 'Svantaggio prove' },
      'Esausto 2': { name: 'Esausto 2', description: 'Velocità metà' },
      'Esausto 3': { name: 'Esausto 3', description: 'Svantaggio attacchi e TS' },
      'Esausto 4': { name: 'Esausto 4', description: 'PF max metà' },
      'Esausto 5': { name: 'Esausto 5', description: 'Velocità 0' },
      'Esausto 6': { name: 'Esausto 6', description: 'Morte' },
    },
    exhaustionEffects: {
      1: 'Svantaggio prove caratteristica',
      2: 'Velocità dimezzata',
      3: 'Svantaggio attacchi e TS',
      4: 'PF massimi dimezzati',
      5: 'Velocità 0',
      6: 'Morte',
    },
    exhaustionLevelTitle: 'Livello Esaurimento',
    exhaustionLevelPrefix: 'Livello ',
    customStatusTitle: 'Status Personalizzato',
    customStatusPlaceholder: 'Nome status...',
    statusRegenPerTurn: 'PF per turno',
    statusBleedPerTurn: 'Danno per turno',
  },
  en: {
    // Header
    language: 'Language',
    round: 'Round',
    combat: 'Combat',
    
    // Home Screen
    selectMode: 'Select Mode',
    selectModeDesc: 'Choose the mode that fits your game and start tracking combat',
    personalTracking: "I'm a player",
    personalHubTitle: 'Player Hub',
    personalTrackingDesc: 'Create characters, track HP and initiative, and run combat solo or with your party',
    masterMode: 'Master Mode',
    masterModeDesc: 'Create a multiplayer lobby',
    masterModeDescLong: 'Are you the Dungeon Master? Create a lobby, share the code with players, and manage initiative, HP and turns for everyone in real time.',
    masterOffline: "I'm a master",
    masterOfflineDesc: 'Run tabletop combat: initiative, turns, and HP. Prepare your session with NPCs and notes, then jump into battle.',
    masterHubTitle: 'Master Hub',
    masterHubDesc: 'Choose how to prepare or enter battle.',
    sessionPrep: 'Session prep',
    sessionPrepDesc: 'Organise named sessions: notes, timeline, and places with encounters, dialogues, objects, characters and missions per location.',
    sessionPrepDescLong: 'Named sessions: notes, timeline, and places (encounters, dialogues, objects, missions). Save and reopen when needed.',
    sessionPrepEditorDesc: 'Top: notes and timeline. Below: places. In each place add encounters, dialogues, objects, characters, missions, checklists. Name + Save.',
    noSavedSessions: 'No sessions saved. Click "New session" to create one (name, notes, places). Save to retrieve later.',
    noPlaces: 'No places. Click "Add place" and fill encounters, dialogues, objects, characters, missions for that location.',
    coinPouchTitle: 'Coin pouch',
    coinPouchButton: 'Wallet',
    coinPouchCurrent: 'Current balance',
    coinPouchTotalCopper: 'Total in copper',
    coinPouchAdd: 'Add coins',
    coinPouchAddButton: 'Add',
    coinPouchSpend: 'Spend coins',
    coinPouchSpendEquivalent: 'Equivalent',
    coinPouchSpendButton: 'Spend',
    coinPouchInsufficient: 'Insufficient balance.',
    coinPouchEnterAmount: 'Enter the amount to spend.',
    coinPouchSpent: 'Spend applied.',
    coinPlatino: 'MP',
    coinOro: 'MO',
    coinElettro: 'ME',
    coinArgento: 'MA',
    coinRame: 'MR',
    coinPouchEmptyAll: 'Empty all',
    coinPouchEmptyConfirmTitle: 'Empty the pouch?',
    coinPouchEmptyConfirmDesc: 'Balance set to zero. Action cannot be undone.',
    coinPouchEmptyConfirmButton: 'Empty all',
    manageNpcEnemies: 'Manage NPCs/Enemies',
    manageNpcDesc: 'Create and edit presets for NPCs, enemies and companions: HP, AC, initiative and notes to use them quickly in battle.',
    manageNpcDescLong: 'Presets for NPCs, enemies, companions: name, HP, AC, initiative bonus, speed, notes. Add in battle with one click.',
    npcPresetsEmpty: 'No presets. Click "New preset": name, HP, AC, initiative bonus, type, notes. Then use them in battle.',
    joinLobby: 'Join Lobby',
    joinLobbyDesc: 'Join an existing lobby',
    joinLobbyDescLong: 'Enter the DM\'s code to join and follow combat in real time.',
    multiplayer: 'Multiplayer',
    multiplayerBeta: 'Beta',
    inDevelopment: 'In Development',
    comingSoon: 'Coming soon',
    installAppTitle: 'Install the site as an app',
    installAppStep1: 'Chrome/Edge: install icon (⊕) in address bar or Menu → Install CoCo.',
    installAppStep2: 'Safari (Mac): File → Add to Dock.',
    installAppStep3: 'Firefox: menu (≡) → Install.',
    installAppStepIos: 'iPhone/iPad: Safari → Share → Add to Home Screen.',
    installAppStepAndroid: 'Android: Chrome → Menu (⋮) → Add to Home screen / Install app.',
    installAppDontShow: 'Don\'t show again',
    installAppNotNow: 'Not now',
    installAppLetsGo: 'Let\'s go!',
    installAppHint: 'Install CoCo as an app',
    multiplayer: 'Multiplayer',
    multiplayerDesc: 'Create a lobby or join with a code to play online',
charactersHomeDesc: 'Create or delete your characters',
    ariaThemeAccent: 'Theme and accent',
    themeLabel: 'Theme',
    accentLabel: 'Accent',
    themeLight: 'Light',
    themeDark: 'Dark',
    close: 'Close',
    remove: 'Remove',
    unpin: 'Unpin',
    pinInitiative: 'Pin at top',
    supportKofi: 'Support the project on Ko-fi',
    kofiHideBanner: 'Hide banner',
    kofiShowBanner: 'Show Ko-fi support',
    footerSupportText: 'CoCo is ad-free and free to use (but not free for me 😔), so if you want:',
    footerMadeWithLove: 'Made with love in 2026 by TakaDev 💛',
    privacyPolicy: 'Privacy',
    privacyTitle: 'Privacy Policy',
    privacyMetaDescription: 'CoCo (Combat Companion) privacy policy: data processed, local storage, multiplayer, and third-party services.',
    privacyLastUpdated: 'Last updated: June 28, 2026',
    privacyIntro: 'CoCo (Combat Companion) is a web app for D&D 5e combat management, available at combatco.app and as an installable app (PWA/TWA). This policy describes how we handle personal data in accordance with applicable privacy laws, including the EU GDPR.',
    backToHome: 'Back to home',
    privacySections: [
      {
        title: '1. Data controller',
        body: 'The data controller is TakaDev, developer of CoCo (Combat Companion).\nFor privacy requests, contact us via https://combatco.app.',
      },
      {
        title: '2. Data we process',
        body: 'CoCo does not require registration or user accounts. Data that may be processed includes:\n• Data you voluntarily enter (character names, game notes, combat data, session prep), stored mainly on your device.\n• Anonymous or aggregated technical data (e.g. page visits) via Vercel Analytics.\n• In multiplayer mode: PeerJS session identifiers and game data exchanged in real time between connected participants.\n• App preferences (language, theme, accent) stored locally in the browser.',
      },
      {
        title: '3. Purposes and legal basis',
        body: 'We process data to:\n• Provide app features (combat, characters, session prep, multiplayer).\n• Improve service stability and usability.\n• Comply with legal obligations.\nLegal bases include contract performance (GDPR Art. 6.1.b), legitimate interest in improving the product (Art. 6.1.f), and consent where applicable for optional third-party services.',
      },
      {
        title: '4. On-device storage',
        body: 'Most game data is stored in localStorage on your device. You can delete it anytime by clearing site/app data in your browser or uninstalling the app. We do not permanently store your offline game content on our own servers.',
      },
      {
        title: '5. Multiplayer mode',
        body: 'Multiplayer uses PeerJS for peer-to-peer connections between Master and players. Game data is transmitted directly between connected devices and is not permanently archived on a CoCo server. PeerJS signaling servers may process connection metadata needed to establish communication.',
      },
      {
        title: '6. Third-party services',
        body: 'The app may integrate or link to external services, including:\n• Vercel Analytics (anonymous/aggregate usage statistics)\n• Google Fonts (font delivery)\n• Ko-fi (optional project support widget)\n• PeerJS (multiplayer)\n• Google Play (Android TWA distribution)\nEach provider processes data under its own privacy policy.',
      },
      {
        title: '7. Your rights',
        body: 'Where applicable, you have rights of access, rectification, erasure, restriction, objection, and portability. You may withdraw consent at any time without affecting prior lawful processing. You may also lodge a complaint with your local data protection authority.',
      },
      {
        title: '8. Children',
        body: 'CoCo is intended for tabletop RPG players; we do not knowingly collect personal data from children under 16 without parental consent.',
      },
      {
        title: '9. Changes',
        body: 'We may update this policy to reflect legal or functional changes. The last update date is shown at the top of this page.',
      },
    ],
    homeAppIntro: 'CoCo is a D&D 5e combat tracker: manage initiative, turns, hit points (HP), statuses, notes, and session prep quickly and clearly for Masters and Players.',
    howItWorksCta: 'How CoCo works',
    guideShort: 'Guide',
    howItWorksTitle: 'How CoCo works',
    howItWorksIntro: 'Quick CoCo guide for D&D 5e initiative and combat management: learn how to use turn tracking, HP, statuses, and Master tools easily.',
    howItWorksInitiativeTitle: '1) D&D 5e initiative tracker',
    howItWorksInitiativeBody: 'Track initiative order, active turn, and combat round in a few taps. Perfect for keeping table pace without losing key information.',
    howItWorksHpTitle: '2) HP, statuses, and resources',
    howItWorksHpBody: 'Update hit points (HP), KO, conditions, spell slots, and turn resources quickly for characters and NPCs in one clear view.',
    howItWorksPrepTitle: '3) Master tools for session prep',
    howItWorksPrepBody: 'Organize places, notes, NPCs, dialogues, objects, and quests before session time. In play, everything is ready in one place.',
    enterBattleDesc: 'Live lobby and combat tracking',
    inBattle: 'in battle',
    nextRound: 'Next round',
    combatants: 'combatants',
    addPreset: 'New preset',
    notes: 'Notes',
    notesPlaceholder: 'Traits, abilities, description...',
    sessionPrepPlaces: 'Places',
    addPlace: 'Add place',
    pasteFullCode: 'Paste the link or code you received from the Master',
    invalidCode: 'Invalid lobby code',
    heart: 'Heart',
    toggleKo: 'Toggle KO',
    characterFormDesc: 'Character form',
    combatantFormDesc: 'Combatant form',
    nameExample: 'E.g.: {name}',
    sessionPrepNotes: 'Notes',
    sessionPrepTimeline: 'Timeline',
    addNote: 'Add note...',
    addEvent: 'Add event...',
    sessionPrepDialogues: 'Dialogues',
    sessionPrepEncounters: 'Encounters',
    sessionPrepObjects: 'Objects',
    sessionPrepCharacters: 'Characters',
    sessionPrepMissions: 'Missions',
    addDialogue: 'Add dialogue...',
    addEncounter: 'Add encounter...',
    addObject: 'Add object...',
    addMission: 'Add mission...',
    addChecklistItem: 'Add item...',
    checklist: 'Checklist',
    empty: 'Empty',
    newSession: 'New session',
    newPlace: 'New place',
    savedSessions: 'Saved sessions',
    sessionNamePlaceholder: 'Session name',
    sessionUnnamed: 'Unnamed session',
    unnamedPlace: 'Unnamed',
    open: 'Open',
    saved: 'Saved',
    deleted: 'Deleted',
    deleteSessionConfirm: 'Delete this session?',
    deletePresetConfirm: 'Delete this preset?',
    addAll: 'Add all',
    selectCharacters: 'Select characters',
    selectMultiple: 'You can select multiple characters',
    selectedCount: 'Selected',
    clearSelection: 'Clear selection',
    noCharacterSelected: 'No character selected',
    charactersAdded: 'characters added',

    // Characters
    noCharacters: 'No characters',
    createFirstCharacter: 'Create first character',
    addCharacter: 'New Character',
    addCharacterFromListDesc: 'Choose a character from Characters',
    editCharacter: 'Edit Character',
    characterSaved: 'Character saved',
    characterUpdated: 'Character updated',
    characterDeleted: 'Character deleted',
    characterDuplicated: 'Character duplicated',
    addedToCombat: 'added to combat',
    alreadyInBattle: 'already in battle',
    goToCombat: 'Go to Combat',
    enterBattle: 'Enter Battle',
    fightWith: 'Fight with',
    selected: 'selected',
    deselect: 'Deselect',
    selectAll: 'Select all',
    charactersSelected: 'characters selected',
    xp: 'XP',
    xpTotal: 'Total XP',
    addXp: 'Add earned XP',
    addXpAction: 'Add XP',
    editTotalXp: 'Edit total XP',
    xpGained: 'XP added',
    xpTotalUpdated: 'Total XP updated',
    
    // Tutorials
    saveTutorialTitle: 'Save characters',
    saveTutorialDesc: 'Header: import/export characters to JSON.',
    battleTutorialTitle: 'Enter battle',
    battleTutorialDesc: 'Select characters (checkboxes) and click "Fight with X selected".',
    dontShowAgain: 'Don\'t show again',
    tutorialsDisabled: 'Tutorials disabled',
    tutorialTitle: 'Tutorial',
    tutorialNext: 'Next',
    tutorialStart: 'Start',
    tutorialSkip: 'Skip',
    tutorialPersonalWelcomeTitle: 'Personal tracking',
    tutorialPersonalWelcomeContent: 'Manage characters and combat locally, no connection needed.',
    tutorialPersonal1Title: '1. Characters',
    tutorialPersonal1Content: '\'New Character\' to create and save. Reuse in future sessions.',
    tutorialPersonal2Title: '2. Combat',
    tutorialPersonal2Content: '\'Combat\' on a character to add to battle. Add multiple if needed.',
    tutorialPersonal3Title: '3. Turns',
    tutorialPersonal3Content: 'Buttons for HP, statuses, next turn. Initiative tracked automatically.',
    tutorialMasterWelcomeTitle: 'Offline master',
    tutorialMasterWelcomeContent: 'Full combat with players, NPCs, enemies, companions.',
    tutorialMaster1Title: '1. Types',
    tutorialMaster1Content: 'Players (white), NPC allies (blue), Enemies (red), Companions (green).',
    tutorialMaster2Title: '2. Add',
    tutorialMaster2Content: '\'Add\' → choose type. You can hide NPC/enemy HP and AC.',
    tutorialMaster3Title: '3. Turns',
    tutorialMaster3Content: 'Initiative at top. \'Next Turn\' to advance. Death saves for KO\'d allies.',
    
    // Temp HP
    tempHp: 'Temp HP',
    tempHpShort: 'Temp',
    addTempHp: 'Add Temp HP',
    
    // Player status at a glance
    playerStatus: 'Player Status',
    healthy: 'Healthy',
    injured: 'Injured',
    critical: 'Critical',
    down: 'Down',
    
    // Master Lobby
    createOrResume: 'Create or Resume Lobby',
    createNewLobby: 'Create New Lobby',
    resumeLobby: 'Resume Lobby',
    lobbyCode: 'Lobby Code',
    lobbyShareHint: 'Share link or QR to let players join',
    codeCopied: 'Code copied',
    linkCopied: 'Link copied',
    copyLink: 'Copy Link',
    connectedPlayers: 'Connected Players',
    waitingForPlayers: 'Waiting for players...',
    closeLobby: 'Close Lobby',
    lobbyClosed: 'Lobby closed',
    lobbyResumed: 'Lobby resumed',
    addNPC: 'Add NPC/Monster',
    addQuickCombatant: 'Quick Add',
    more: 'more',
    fullCodeCopied: 'The full code includes the Master ID',
    showQR: 'Show QR Code',
    hideQR: 'Hide QR',
    rejoinLobbySavedMaster: 'Master Lobby saved',
    rejoinLobbySavedPlayer: 'Player Lobby saved',
    rejoinLobbyButton: 'Rejoin',
    dismissSavedLobby: 'Dismiss lobby',
    
    // Combatant types
    player: 'Player',
    npcAlly: 'NPC Ally',
    enemyType: 'Enemy',
    companion: 'Companion',
    combatantType: 'Combatant Type',
    concentration: 'Concentration',
    concentrationCheckTitle: 'Concentration saving throw',
    concentrationCheckDesc: 'd20 Constitution: 10+ success, below 10 failure.',
    concentrationSuccessBtn: 'Success',
    concentrationFailureBtn: 'Failure',
    concentrationSuccess: 'Concentration maintained',
    concentrationLost: 'Concentration lost',
    advDis: 'Advantage/Disadvantage',
    advantage: 'Advantage',
    disadvantage: 'Disadvantage',
    normal: 'Normal',
    action: 'Action',
    actionShort: 'Action',
    bonusAction: 'Bonus action',
    bonusActionShort: 'Bonus',
    reaction: 'Reaction',
    reactionShort: 'Reaction',
    advantageShort: 'Advantage',
    disadvantageShort: 'Disadv.',
    actionTooltip: 'Action (reset next turn)',
    bonusActionTooltip: 'Bonus action (reset next turn)',
    reactionTooltip: 'Reaction (reset next round)',
    dash: 'Dash',
    
    // Enemy/Ally
    enemy: 'Enemy',
    ally: 'Ally',
    isEnemy: 'Is enemy',
    hpVisible: 'HP visible to players',
    hpHidden: 'HP hidden',
    acVisible: 'AC visible',
    
    // Join Lobby
    enterLobbyCode: 'Enter Lobby Code',
    yourName: 'Your Name',
    continue: 'Continue',
    selectCharacter: 'Select Character',
    noSavedCharacters: 'No saved characters',
    joinWithoutCharacter: 'Join without character',
    connected: 'Connected!',
    yourCharacters: 'Your Characters',
    you: 'You',
    waitingForMaster: 'Waiting for Master...',
    connecting: 'Connecting...',
    leaveLobby: 'Leave Lobby',
    enterWithQRCode: 'Enter with QR code',
    orEnterManually: 'Or enter the code below',
    scanQRCode: 'Scan QR code',
    scanQRCodeDesc: 'Scan the Master\'s QR to fill in the code.',
    qrNoCamera: 'No camera available',
    qrCameraError: 'Unable to start camera',
    qrStartingCamera: 'Starting camera...',
    qrCodeScanned: 'Code scanned!',
    viewBattlefield: 'Go to battlefield',

    // Combat
    initiative: 'Initiative',
    initiativeOrder: 'Initiative Order',
    hp: 'HP',
    ac: 'AC',
    currentTurn: 'Current turn',
    shortRest: 'Short Rest',
    shortRestZeroDice: '0 = rest without spending hit dice',
    longRest: 'Long Rest',
    shortRestShort: 'Short rest',
    longRestShort: 'Long rest',
    shortRestAll: 'Short Rest (all)',
    longRestAll: 'Long Rest (all)',
    shortRestDone: 'Short rest done',
    longRestDone: 'Long rest done',
    shortRestAllDone: 'Short rest done (all)',
    longRestAllDone: 'Long rest done (all)',
    shortRestTitle: 'Short Rest – Hit Dice',
    shortRestNumDice: 'Number of dice',
    shortRestDieType: 'Die type',
    shortRestRoll: 'Roll',
    shortRestApply: 'Apply',
    shortRestResult: 'Result',
    shortRestRecovered: 'HP recovered',
    shortRestLog: 'took a short rest',
    longRestLog: 'took a long rest',
    ko: 'KO',
    
    // Actions
    nextTurn: 'Next Turn',
    addCombatant: 'Add',
    reset: 'Reset',
    exportJson: 'Export JSON',
    importJson: 'Import JSON',
    dataMenu: 'Data',
    backupComplete: 'Full backup',
    backupCompleteDesc: 'Characters + combat + settings',
    restoreBackup: 'Restore backup',
    restoreBackupDesc: 'Import full backup (replaces everything)',
    exportCharactersOnly: 'Characters only (export)',
    importCharactersOnly: 'Characters only (import)',
    dataMenuCharactersSection: 'Characters only',
    menu: 'Menu',
    status: 'Status',
    modify: 'Modify',
    duplicate: 'Duplicate',
    
    // Combatant card
    damage: 'Damage',
    heal: 'Heal',
    customAmount: 'Amount',
    apply: 'Apply',
    edit: 'Edit',
    delete: 'Delete',
    
    // Death Saves
    deathSaves: 'Death Saving Throws',
    success: 'Success',
    failure: 'Failure',
    stabilized: 'Stabilized!',
    backTo1HP: 'Back to 1 HP',
    dead: 'Dead',
    
    // Add/Edit modal
    addCombatantTitle: 'Add Combatant',
    editCombatantTitle: 'Edit Combatant',
    name: 'Name',
    namePlaceholder: 'E.g. Goblin, Warrior...',
    maxHp: 'Max HP',
    currentHp: 'Current HP',
    initiativeValue: 'Initiative',
    initiativeBonus: 'Initiative bonus',
    speed: 'Speed',
    speedMovement: 'Movement speed',
    speedUnit: 'ft/s',
    hitDice: 'Hit dice',
    hitDiceTotal: 'Number of dice',
    hitDiceSides: 'Die type',
    hitDiceAvailable: 'Dice available',
    spellSlots: 'Spell slots',
    statuses: 'Statuses',
    addStatus: 'Add Status',
    statusName: 'Status Name',
    statusDuration: 'Duration (rounds)',
    dotLabel: 'Damage per turn',
    dotDamage: 'Damage',
    dotDuration: 'Duration (rounds)',
    optional: 'optional',
    famiglio: 'Familiar',
    famiglioOf: 'Familiar of',
    famiglioOfPlaceholder: 'Select character',
    searchCharacter: 'Search character...',
    save: 'Save',
    cancel: 'Cancel',
    
    // Status presets
    statusPresets: [
      'Poisoned', 'Stunned', 'Blinded', 'Paralyzed',
      'Burning', 'Frozen', 'Charmed', 'Frightened',
      'Prone', 'Restrained', 'Invisible', 'Incapacitated'
    ],
    
    // Messages
    combatantAdded: 'Combatant added',
    combatantUpdated: 'Combatant updated',
    combatantDeleted: 'Combatant deleted',
    combatReset: 'Combat reset',
    dataExported: 'Data exported',
    dataImported: 'Data imported',
    importError: 'Import error',
    turnChanged: 'Turn of',
    quickInitiative: 'Quick initiative',
    initiativeRolled: 'Initiative rolled',
    quickInitiativePromptDesc: 'Roll initiative for:',
    quickInitiativeForAll: 'Everyone',
    quickInitiativeNpcEnemiesOnly: 'NPCs and Enemies only',
    dotApplied: 'DoT applied:',
    damagePoints: 'damage',
    statusExpired: 'Status expired:',
    charactersExported: 'characters exported',
    charactersImported: 'characters imported',
    noCharactersToExport: 'No characters to export',
    
    // Confirm
    confirmReset: 'Reset combat?',
    confirmDelete: 'Delete this combatant?',
    yes: 'Yes',
    no: 'No',
    
    // Empty state
    noCombatants: 'No combatants',
    addFirst: 'Add a combatant to start',
    
    // Misc
    characters: 'Characters',
    back: 'Back',
    backToHome: 'Back to home',
    eventHistory: 'History',
    collapseAll: 'Collapse all',
    expandAll: 'Expand all',
    noEvents: 'No events recorded',
    battleNotes: 'Battle notes',
    battleNotesPlaceholder: 'Notes, objectives, reminders...',
    npcPresetsTitle: 'NPC Presets',
    npcPresetNew: 'New preset',
    addToBattleShort: 'To battle',
    npcPresetSaved: 'Preset saved',
    saveToPresets: 'Save to presets',
    presetsList: 'Saved presets',
    saveFromBattle: 'Save as preset from battle',
    saveAsPresetShort: 'Save preset',
    clearHistory: 'Clear history',
    clear: 'Clear',
    historyCleared: 'History cleared',
    turnOf: 'Turn of',
    tookDamage: 'took',
    damageText: 'damage',
    wasHealed: 'was healed for',
    hpText: 'HP',
    gainedStatus: 'is now',
    lostStatus: 'is no longer',
    wasAdded: 'joined combat',
    wasRemoved: 'was removed',
    stabilizedText: 'stabilized',
    diedText: 'died',
    koText: 'went down',
    revivedText: 'was revived',
    tempHpGained: 'gained',
    tempHpText: 'temp HP',
    deathSaveSuccess: 'passed a death save',
    deathSaveFailure: 'failed a death save',
    statusDictionary: {
      'Accecato': { name: 'Blinded', description: 'Cannot see. Disadvantage on attacks; attacks against have advantage.' },
      'Affascinato': { name: 'Charmed', description: 'Cannot attack or target charmer with harm.' },
      'Afferrato': { name: 'Grappled', description: 'Speed 0, no speed bonuses.' },
      'Assordato': { name: 'Deafened', description: 'Cannot hear. Fails hearing-based checks.' },
      'Avvelenato': { name: 'Poisoned', description: 'Disadvantage on attacks and checks.' },
      'Concentrazione': { name: 'Concentration', description: 'Maintains spell; damage triggers concentration save.' },
      'Esausto': { name: 'Exhaustion', description: 'Levels 1–6: disadvantage to death.' },
      'Impaurito': { name: 'Frightened', description: 'Disadvantage while seeing source; cannot move closer.' },
      'Incapacitato': { name: 'Incapacitated', description: 'No actions or reactions.' },
      'Invisibile': { name: 'Invisible', description: 'Cannot be seen. Disadvantage vs; advantage on own attacks.' },
      'Paralizzato': { name: 'Paralyzed', description: 'Incapacitated, speed 0. Fails Str/Dex. Melee advantage, crit 5 ft.' },
      'Pietrificato': { name: 'Petrified', description: 'Stone. Incapacitated, weight x10.' },
      'Privo di sensi': { name: 'Unconscious', description: 'Incapacitated, prone. Melee 5 ft = crit.' },
      'Prono': { name: 'Prone', description: 'On ground. Disadvantage ranged; advantage melee 5 ft.' },
      'Rallentato': { name: 'Slowed', description: 'Speed halved, -2 AC. One action or bonus per turn, no reaction.' },
      'Sanguinante': { name: 'Bleeding', description: 'Damage each turn until healed or stabilized.' },
      'Sorpreso': { name: 'Surprised', description: 'First round: no move, action, or reaction.' },
      'Spaventato': { name: 'Frightened', description: 'Disadvantage while seeing source; cannot move closer.' },
      'Stordito': { name: 'Stunned', description: 'Incapacitated, speed 0. Fails Str/Dex. Cannot speak.' },
      'Trattenuto': { name: 'Restrained', description: 'Speed 0. Disadvantage attacks; advantage vs; disadvantage Dex saves.' },
      'Benedizione': { name: 'Bless', description: '+1d4 to one attack or save (roll after die).' },
      'Eroismo': { name: 'Heroism', description: 'Immune fear. Temp HP each turn.' },
      'Fretta': { name: 'Haste', description: 'Speed x2, +2 AC, advantage Dex saves, extra action (limited).' },
      'Guidare': { name: 'Guidance', description: '+1d4 to one check (roll after die).' },
      'Protezione': { name: 'Protection', description: 'Reaction: disadvantage on attack vs adjacent ally or +1d4 ally save.' },
      'Rigenerazione': { name: 'Regeneration', description: 'Regains HP each turn (e.g. 10).' },
      'Scudo': { name: 'Shield', description: 'Reaction: +5 AC vs one attack until next turn.' },
      'Volare': { name: 'Fly', description: 'Can fly. Flying speed as effect.' },
      'Altro...': { name: 'Other...', description: 'Custom status: name and duration.' },
      'Esausto 1': { name: 'Exhaustion 1', description: 'Disadvantage on checks' },
      'Esausto 2': { name: 'Exhaustion 2', description: 'Speed halved' },
      'Esausto 3': { name: 'Exhaustion 3', description: 'Disadvantage attacks and saves' },
      'Esausto 4': { name: 'Exhaustion 4', description: 'HP max halved' },
      'Esausto 5': { name: 'Exhaustion 5', description: 'Speed 0' },
      'Esausto 6': { name: 'Exhaustion 6', description: 'Death' },
    },
    exhaustionEffects: {
      1: 'Disadvantage on ability checks',
      2: 'Speed halved',
      3: 'Disadvantage on attack rolls and saving throws',
      4: 'Hit point maximum halved',
      5: 'Speed reduced to 0',
      6: 'Death',
    },
    exhaustionLevelTitle: 'Exhaustion Level',
    exhaustionLevelPrefix: 'Level ',
    customStatusTitle: 'Custom Status',
    customStatusPlaceholder: 'Status name...',
    statusRegenPerTurn: 'HP per turn',
    statusBleedPerTurn: 'Damage per turn',
  },
  es: {
    // Header
    language: 'Idioma',
    round: 'Asalto',
    combat: 'Combate',

    // Home Screen
    selectMode: 'Selecciona modo',
    selectModeDesc: 'Elige el modo que mejor se adapte a tu partida y empieza a seguir el combate',
    personalTracking: 'Soy un jugador',
    personalHubTitle: 'Hub del Jugador',
    personalTrackingDesc: 'Crea personajes, gestiona PV e iniciativa y combate en solitario o con tu grupo',
    masterMode: 'Modo Maestro',
    masterModeDesc: 'Crea una sala multijugador',
    masterModeDescLong: '¿Eres el Dungeon Master? Crea una sala, comparte el código con los jugadores y gestiona iniciativa, PV y turnos para todos en tiempo real.',
    masterOffline: 'Soy un master',
    masterOfflineDesc: 'Gestiona el combate en la mesa: iniciativa, turnos y PV. Prepara la sesión con PNJ y notas, luego entra en batalla.',
    masterHubTitle: 'Hub del Master',
    masterHubDesc: 'Elige cómo prepararte o entrar en batalla.',
    sessionPrep: 'Preparación de sesión',
    sessionPrepDesc: 'Organiza sesiones con nombre: notas, línea temporal y lugares con encuentros, diálogos, objetos, personajes y misiones por ubicación.',
    sessionPrepDescLong: 'Sesiones con nombre: notas, línea temporal y lugares (encuentros, diálogos, objetos, misiones). Guarda y abre cuando quieras.',
    sessionPrepEditorDesc: 'Arriba: notas y línea temporal. Abajo: lugares. En cada uno añade encuentros, diálogos, objetos, personajes, misiones y listas. Nombre + Guardar.',
    noSavedSessions: 'Ninguna sesión guardada. Pulsa "Nueva sesión" (nombre, notas, lugares). Guarda para recuperar después.',
    noPlaces: 'Sin lugares. Pulsa "Añadir lugar" y rellena encuentros, diálogos, objetos, personajes y misiones.',
    coinPouchTitle: 'Bolsa de monedas',
    coinPouchButton: 'Monedero',
    coinPouchCurrent: 'Saldo actual',
    coinPouchTotalCopper: 'Total en cobre',
    coinPouchAdd: 'Añadir monedas',
    coinPouchAddButton: 'Añadir',
    coinPouchSpend: 'Gastar monedas',
    coinPouchSpendEquivalent: 'Equivalente',
    coinPouchSpendButton: 'Gastar',
    coinPouchInsufficient: 'Saldo insuficiente.',
    coinPouchEnterAmount: 'Introduce la cantidad a gastar.',
    coinPouchSpent: 'Gasto aplicado.',
    coinPlatino: 'MP',
    coinOro: 'MO',
    coinElettro: 'ME',
    coinArgento: 'MA',
    coinRame: 'MR',
    coinPouchEmptyAll: 'Vaciar todo',
    coinPouchEmptyConfirmTitle: '¿Vaciar la bolsa?',
    coinPouchEmptyConfirmDesc: 'Saldo a cero. Acción irreversible.',
    coinPouchEmptyConfirmButton: 'Vaciar todo',
    manageNpcEnemies: 'Gestionar PNJ/Enemigos',
    manageNpcDesc: 'Crea y edita presets de PNJ, enemigos y compañeros: PV, CA, iniciativa y notas para usarlos rápido en batalla.',
    manageNpcDescLong: 'Presets para PNJ, enemigos y compañeros: nombre, PV, CA, bonus iniciativa, velocidad, notas. Añade en batalla con un clic.',
    npcPresetsEmpty: 'Sin presets. Pulsa "Nuevo preset": nombre, PV, CA, bonus iniciativa, tipo, notas. Luego úsalos en batalla.',
    joinLobby: 'Unirse a sala',
    joinLobbyDesc: 'Únete a una sala existente',
    joinLobbyDescLong: 'Introduce el código del Master para unirte y seguir el combate en tiempo real.',
    multiplayer: 'Multijugador',
    multiplayerBeta: 'Beta',
    inDevelopment: 'En desarrollo',
    comingSoon: 'Próximamente',
    installAppTitle: 'Instalar el sitio como app',
    installAppStep1: 'Chrome/Edge: icono (⊕) en barra de direcciones o Menú → Instalar CoCo.',
    installAppStep2: 'Safari (Mac): Archivo → Añadir al Dock.',
    installAppStep3: 'Firefox: menú (≡) → Instalar.',
    installAppStepIos: 'iPhone/iPad: Safari → Compartir → Añadir a pantalla de inicio.',
    installAppStepAndroid: 'Android: Chrome → Menú (⋮) → Añadir a pantalla de inicio / Instalar app.',
    installAppDontShow: 'No mostrar de nuevo',
    installAppNotNow: 'Ahora no',
    installAppLetsGo: '¡Empecemos!',
    installAppHint: 'Instalar CoCo como app',
    multiplayer: 'Multijugador',
    multiplayerDesc: 'Crea una sala o únete con un código para jugar en línea',
    charactersHomeDesc: 'Crea o elimina tus personajes',
    ariaThemeAccent: 'Tema y acento',
    themeLabel: 'Tema',
    accentLabel: 'Acento',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    close: 'Cerrar',
    remove: 'Quitar',
    unpin: 'Desbloquear',
    pinInitiative: 'Fijar arriba',
    supportKofi: 'Apoya el proyecto en Ko-fi',
    kofiHideBanner: 'Ocultar banner',
    kofiShowBanner: 'Mostrar apoyo Ko-fi',
    footerSupportText: 'CoCo no tiene anuncios y es gratis (aunque para mi no 😔), así que si quieres:',
    footerMadeWithLove: 'Made with love in 2026 by TakaDev 💛',
    privacyPolicy: 'Privacidad',
    privacyTitle: 'Política de privacidad',
    privacyMetaDescription: 'Política de privacidad de CoCo (Combat Companion): datos tratados, almacenamiento local, multijugador y servicios de terceros.',
    privacyLastUpdated: 'Última actualización: 28 de junio de 2026',
    privacyIntro: 'CoCo (Combat Companion) es una web app para gestionar combates en D&D 5e, disponible en combatco.app y como app instalable (PWA/TWA). Esta política describe cómo tratamos los datos personales conforme al RGPD y la normativa aplicable.',
    backToHome: 'Volver al inicio',
    privacySections: [
      {
        title: '1. Responsable del tratamiento',
        body: 'El responsable es TakaDev, desarrollador de CoCo (Combat Companion).\nPara consultas de privacidad, contáctanos en https://combatco.app.',
      },
      {
        title: '2. Datos que tratamos',
        body: 'CoCo no requiere registro ni cuenta de usuario. Los datos que pueden tratarse incluyen:\n• Datos introducidos voluntariamente (nombres, notas, combate, preparación), guardados principalmente en el dispositivo.\n• Datos técnicos anónimos o agregados (p. ej. visitas) mediante Vercel Analytics.\n• En multijugador: identificadores PeerJS y datos de juego intercambiados en tiempo real.\n• Preferencias de la app (idioma, tema, acento) guardadas localmente.',
      },
      {
        title: '3. Finalidades y base legal',
        body: 'Tratamos datos para:\n• Ofrecer las funciones de la app.\n• Mejorar estabilidad y usabilidad.\n• Cumplir obligaciones legales.\nBases legales: ejecución del servicio (RGPD art. 6.1.b), interés legítimo (art. 6.1.f) y consentimiento cuando aplique.',
      },
      {
        title: '4. Almacenamiento en el dispositivo',
        body: 'La mayoría de los datos de juego se guardan en localStorage. Puedes eliminarlos borrando los datos del sitio o desinstalando la app. No almacenamos permanentemente el contenido offline en servidores propios.',
      },
      {
        title: '5. Modo multijugador',
        body: 'El multijugador usa PeerJS para conexiones peer-to-peer. Los datos se transmiten entre dispositivos conectados y no se archivan permanentemente en un servidor CoCo. Los servidores de señalización PeerJS pueden procesar metadatos de conexión.',
      },
      {
        title: '6. Servicios de terceros',
        body: 'La app puede integrar servicios externos: Vercel Analytics, Google Fonts, Ko-fi, PeerJS y Google Play (TWA Android). Cada proveedor trata los datos según su propia política de privacidad.',
      },
      {
        title: '7. Tus derechos',
        body: 'Tienes derecho de acceso, rectificación, supresión, limitación, oposición y portabilidad cuando corresponda. Puedes presentar reclamación ante la autoridad de protección de datos de tu país.',
      },
      {
        title: '8. Menores',
        body: 'No recopilamos conscientemente datos de menores de 16 años sin consentimiento parental.',
      },
      {
        title: '9. Cambios',
        body: 'Podemos actualizar esta política. La fecha de última actualización figura al inicio de la página.',
      },
    ],
    homeAppIntro: 'CoCo es un combat tracker para D&D 5e: gestiona iniciativa, turnos, puntos de vida (PV), estados, notas y preparación de sesión de forma rápida y ordenada para Master y jugadores.',
    howItWorksCta: '¿Cómo funciona CoCo?',
    guideShort: 'Guía',
    howItWorksTitle: 'Cómo funciona CoCo',
    howItWorksIntro: 'Guía rápida de CoCo para iniciativa D&D 5e y gestión de combate: descubre cómo usar turnos, PV, estados y herramientas de Master fácilmente.',
    howItWorksInitiativeTitle: '1) Tracker de iniciativa D&D 5e',
    howItWorksInitiativeBody: 'Controla orden de iniciativa, turno activo y ronda de combate en pocos toques. Ideal para mantener el ritmo en mesa sin perder informacion.',
    howItWorksHpTitle: '2) Gestión de PV, estados y recursos',
    howItWorksHpBody: 'Actualiza rápidamente puntos de vida (PV), KO, condiciones, espacios de conjuro y recursos de turno para personajes y PNJ en una sola vista clara.',
    howItWorksPrepTitle: '3) Herramientas de Master para preparar sesión',
    howItWorksPrepBody: 'Organiza lugares, notas, personajes, dialogos, objetos y misiones antes de la sesion. En partida, todo listo en una sola herramienta.',
    enterBattleDesc: 'Sala y combate en tiempo real',
    inBattle: 'en batalla',
    nextRound: 'Siguiente ronda',
    combatants: 'combatientes',
    addPreset: 'Nuevo preset',
    notes: 'Notas',
    notesPlaceholder: 'Rasgos, habilidades, descripción...',
    sessionPrepPlaces: 'Lugares',
    addPlace: 'Añadir lugar',
    pasteFullCode: 'Pega el enlace o código recibido del Master',
    invalidCode: 'Código de sala no válido',
    heart: 'Corazón',
    toggleKo: 'Alternar KO',
    characterFormDesc: 'Formulario de personaje',
    combatantFormDesc: 'Formulario de combatiente',
    nameExample: 'Ej.: {name}',
    sessionPrepNotes: 'Notas',
    sessionPrepTimeline: 'Línea temporal',
    addNote: 'Añadir nota...',
    addEvent: 'Añadir evento...',
    sessionPrepDialogues: 'Diálogos',
    sessionPrepEncounters: 'Encuentros',
    sessionPrepObjects: 'Objetos',
    sessionPrepCharacters: 'Personajes',
    sessionPrepMissions: 'Misiones',
    addDialogue: 'Añadir diálogo...',
    addEncounter: 'Añadir encuentro...',
    addObject: 'Añadir objeto...',
    addMission: 'Añadir misión...',
    addChecklistItem: 'Añadir elemento...',
    checklist: 'Lista',
    empty: 'Vacío',
    newSession: 'Nueva sesión',
    newPlace: 'Nuevo lugar',
    savedSessions: 'Sesiones guardadas',
    sessionNamePlaceholder: 'Nombre de sesión',
    sessionUnnamed: 'Sesión sin nombre',
    unnamedPlace: 'Sin nombre',
    open: 'Abrir',
    saved: 'Guardado',
    deleted: 'Eliminado',
    deleteSessionConfirm: '¿Eliminar esta sesión?',
    deletePresetConfirm: '¿Eliminar este preset?',
    addAll: 'Añadir todos',
    selectCharacters: 'Seleccionar personajes',
    selectMultiple: 'Puedes seleccionar varios personajes',
    selectedCount: 'Seleccionados',
    clearSelection: 'Deseleccionar todos',
    noCharacterSelected: 'Ningún personaje seleccionado',
    charactersAdded: 'personajes añadidos',

    // Characters
    noCharacters: 'Sin personajes',
    createFirstCharacter: 'Crea el primer personaje',
    addCharacter: 'Nuevo personaje',
    addCharacterFromListDesc: 'Elige un personaje de Personajes',
    editCharacter: 'Editar personaje',
    characterSaved: 'Personaje guardado',
    characterUpdated: 'Personaje actualizado',
    characterDeleted: 'Personaje eliminado',
    characterDuplicated: 'Personaje duplicado',
    addedToCombat: 'añadido al combate',
    alreadyInBattle: 'ya en batalla',
    goToCombat: 'Ir al combate',
    enterBattle: 'Entrar en batalla',
    fightWith: 'Luchar con',
    selected: 'seleccionados',
    deselect: 'Deseleccionar',
    selectAll: 'Seleccionar todo',
    charactersSelected: 'personajes seleccionados',
    xp: 'XP',
    xpTotal: 'XP total',
    addXp: 'Anadir XP ganada',
    addXpAction: 'Anadir XP',
    editTotalXp: 'Editar XP total',
    xpGained: 'XP anadida',
    xpTotalUpdated: 'XP total actualizada',

    // Tutorials
    saveTutorialTitle: 'Guardar personajes',
    saveTutorialDesc: 'Cabecera: importar/exportar personajes en JSON.',
    battleTutorialTitle: 'Entrar en batalla',
    battleTutorialDesc: 'Selecciona personajes (casillas) y pulsa "Luchar con X seleccionados".',
    dontShowAgain: 'No mostrar de nuevo',
    tutorialsDisabled: 'Tutoriales desactivados',
    tutorialTitle: 'Tutorial',
    tutorialNext: 'Siguiente',
    tutorialStart: 'Empezar',
    tutorialSkip: 'Omitir',
    tutorialPersonalWelcomeTitle: 'Seguimiento personal',
    tutorialPersonalWelcomeContent: 'Gestiona personajes y combates en local, sin conexión.',
    tutorialPersonal1Title: '1. Personajes',
    tutorialPersonal1Content: '\'Nuevo personaje\' para crear y guardar. Reutilizables después.',
    tutorialPersonal2Title: '2. Combate',
    tutorialPersonal2Content: '\'Combate\' en un personaje para añadirlo. Puedes añadir varios.',
    tutorialPersonal3Title: '3. Turnos',
    tutorialPersonal3Content: 'Botones para PG, estados y siguiente turno. Iniciativa automática.',
    tutorialMasterWelcomeTitle: 'Maestro offline',
    tutorialMasterWelcomeContent: 'Combate con jugadores, PNJ, enemigos y compañeros.',
    tutorialMaster1Title: '1. Tipos',
    tutorialMaster1Content: 'Jugadores (blanco), PNJ aliados (azul), Enemigos (rojo), Compañeros (verde).',
    tutorialMaster2Title: '2. Añadir',
    tutorialMaster2Content: '\'Añadir\' → elige tipo. Puedes ocultar PG/CA de PNJ y enemigos.',
    tutorialMaster3Title: '3. Turnos',
    tutorialMaster3Content: 'Iniciativa arriba. \'Siguiente turno\' para avanzar. Tiradas de muerte para KO.',

    // Temp HP
    tempHp: 'PG Temp',
    tempHpShort: 'Temp',
    addTempHp: 'Añadir PG Temp',

    // Master Lobby
    createOrResume: 'Crear o reanudar sala',
    createNewLobby: 'Crear nueva sala',
    resumeLobby: 'Reanudar sala',
    lobbyCode: 'Código de sala',
    lobbyShareHint: 'Comparte el enlace o QR para que entren los jugadores',
    codeCopied: 'Código copiado',
    linkCopied: 'Enlace copiado',
    copyLink: 'Copiar enlace',
    connectedPlayers: 'Jugadores conectados',
    waitingForPlayers: 'Esperando jugadores...',
    closeLobby: 'Cerrar sala',
    lobbyClosed: 'Sala cerrada',
    lobbyResumed: 'Sala reanudada',
    fullCodeCopied: 'El código completo incluye el ID del Maestro',
    showQR: 'Mostrar código QR',
    hideQR: 'Ocultar QR',
    rejoinLobbySavedMaster: 'Sala de Maestro guardada',
    rejoinLobbySavedPlayer: 'Sala de Jugador guardada',
    rejoinLobbyButton: 'Reincorporarse',
    dismissSavedLobby: 'Cerrar sala',

    // Player status at a glance
    playerStatus: 'Estado de jugadores',
    healthy: 'Sano',
    injured: 'Herido',
    critical: 'Crítico',
    down: 'Fuera de combate',
    addNPC: 'Añadir PNJ/Monstruo',
    addQuickCombatant: 'Añadir rápido',
    more: 'más',

    // Combatant types
    player: 'Jugador',
    npcAlly: 'PNJ aliado',
    enemyType: 'Enemigo',
    companion: 'Compañero',
    combatantType: 'Tipo de combatiente',
    concentration: 'Concentración',
    concentrationCheckTitle: 'Tirada de salvación de concentración',
    concentrationCheckDesc: 'd20 Constitución: 10+ éxito, menos de 10 fallo.',
    concentrationSuccessBtn: 'Éxito',
    concentrationFailureBtn: 'Fallo',
    concentrationSuccess: 'Concentración mantenida',
    concentrationLost: 'Concentración perdida',
    advDis: 'Ventaja/Desventaja',
    advantage: 'Ventaja',
    disadvantage: 'Desventaja',
    normal: 'Normal',
    action: 'Acción',
    actionShort: 'Acc.',
    bonusAction: 'Acción adicional',
    bonusActionShort: 'Bonus',
    reaction: 'Reacción',
    reactionShort: 'Reac.',
    advantageShort: 'Vent.',
    disadvantageShort: 'Desv.',
    actionTooltip: 'Acción (reset próximo turno)',
    bonusActionTooltip: 'Acción adicional (reset próximo turno)',
    reactionTooltip: 'Reacción (reset próxima ronda)',
    dash: 'Esprintar',

    // Enemy/Ally
    enemy: 'Enemigo',
    ally: 'Aliado',
    isEnemy: 'Es enemigo',
    hpVisible: 'PG visibles para los jugadores',
    hpHidden: 'PG ocultos',
    acVisible: 'CA visible',

    // Join Lobby
    enterLobbyCode: 'Introduce el código de sala',
    yourName: 'Tu nombre',
    continue: 'Continuar',
    selectCharacter: 'Selecciona personaje',
    noSavedCharacters: 'Sin personajes guardados',
    joinWithoutCharacter: 'Entrar sin personaje',
    connected: 'Conectado',
    waitingForMaster: 'Esperando al Maestro...',
    connecting: 'Conectando...',
    leaveLobby: 'Salir de la sala',
    enterWithQRCode: 'Entrar con código QR',
    orEnterManually: 'O introduce el código abajo',
    scanQRCode: 'Escanear código QR',
    scanQRCodeDesc: 'Escanea el QR del Master para rellenar el código.',
    qrNoCamera: 'No hay cámara disponible',
    qrCameraError: 'No se puede iniciar la cámara',
    qrStartingCamera: 'Iniciando cámara...',
    qrCodeScanned: '¡Código leído!',
    viewBattlefield: 'Ir al campo de batalla',
    yourCharacters: 'Tus personajes',
    you: 'Tú',

    // Combat
    initiative: 'Iniciativa',
    initiativeOrder: 'Orden de iniciativa',
    hp: 'PG',
    ac: 'CA',
    currentTurn: 'Turno actual',
    shortRest: 'Descanso corto',
    shortRestZeroDice: '0 = descanso sin gastar dados de vida',
    longRest: 'Descanso largo',
    shortRestShort: 'Desc. corto',
    longRestShort: 'Desc. largo',
    shortRestAll: 'Descanso corto (todos)',
    longRestAll: 'Descanso largo (todos)',
    shortRestDone: 'Descanso corto hecho',
    longRestDone: 'Descanso largo hecho',
    shortRestAllDone: 'Descanso corto hecho (todos)',
    longRestAllDone: 'Descanso largo hecho (todos)',
    shortRestTitle: 'Descanso corto – Dados de vida',
    shortRestNumDice: 'Número de dados',
    shortRestDieType: 'Tipo de dado',
    shortRestRoll: 'Tirar',
    shortRestApply: 'Aplicar',
    shortRestResult: 'Resultado',
    shortRestRecovered: 'PV recuperados',
    shortRestLog: 'ha hecho descanso corto',
    longRestLog: 'ha hecho descanso largo',
    ko: 'KO',

    // Actions
    nextTurn: 'Siguiente turno',
    addCombatant: 'Añadir',
    reset: 'Reiniciar',
    exportJson: 'Exportar JSON',
    importJson: 'Importar JSON',
    dataMenu: 'Datos',
    backupComplete: 'Copia de seguridad completa',
    backupCompleteDesc: 'Personajes + combate + configuración',
    restoreBackup: 'Restaurar copia',
    restoreBackupDesc: 'Importar copia completa (reemplaza todo)',
    exportCharactersOnly: 'Solo personajes (exportar)',
    importCharactersOnly: 'Solo personajes (importar)',
    dataMenuCharactersSection: 'Solo personajes',
    menu: 'Menú',
    status: 'Estado',
    modify: 'Modificar',
    duplicate: 'Duplicar',

    // Combatant card
    damage: 'Daño',
    heal: 'Curar',
    customAmount: 'Cantidad',
    apply: 'Aplicar',
    edit: 'Editar',
    delete: 'Eliminar',

    // Death Saves
    deathSaves: 'Tiradas de salvación de muerte',
    success: 'Éxito',
    failure: 'Fallo',
    stabilized: '¡Estabilizado!',
    backTo1HP: 'Volver a 1 PG',
    dead: 'Muerto',

    // Add/Edit modal
    addCombatantTitle: 'Añadir combatiente',
    editCombatantTitle: 'Editar combatiente',
    name: 'Nombre',
    namePlaceholder: 'Ej. Goblin, Guerrero...',
    maxHp: 'PG máximos',
    currentHp: 'PG actuales',
    initiativeValue: 'Iniciativa',
    initiativeBonus: 'Bonificador de iniciativa',
    speed: 'Velocidad',
    speedMovement: 'Velocidad de movimiento',
    speedUnit: 'm/s',
    hitDice: 'Dados de vida',
    hitDiceTotal: 'Número de dados',
    hitDiceSides: 'Tipo de dado',
    hitDiceAvailable: 'Dados disponibles',
    spellSlots: 'Espacios de conjuro',
    statuses: 'Estados',
    addStatus: 'Añadir estado',
    statusName: 'Nombre del estado',
    statusDuration: 'Duración (asaltos)',
    dotLabel: 'Daño por turno',
    dotDamage: 'Daño',
    dotDuration: 'Duración (asaltos)',
    optional: 'opcional',
    famiglio: 'Familiar',
    famiglioOf: 'Familiar de',
    famiglioOfPlaceholder: 'Seleccionar personaje',
    searchCharacter: 'Buscar personaje...',
    save: 'Guardar',
    cancel: 'Cancelar',

    // Status presets
    statusPresets: [
      'Envenenado', 'Aturdido', 'Cegado', 'Paralizado',
      'Quemado', 'Congelado', 'Hechizado', 'Asustado',
      'Derribado', 'Restringido', 'Invisible', 'Incapacitado',
    ],

    // Messages
    combatantAdded: 'Combatiente añadido',
    combatantUpdated: 'Combatiente actualizado',
    combatantDeleted: 'Combatiente eliminado',
    combatReset: 'Combate reiniciado',
    dataExported: 'Datos exportados',
    dataImported: 'Datos importados',
    importError: 'Error al importar',
    turnChanged: 'Turno de',
    quickInitiative: 'Iniciativa rápida',
    initiativeRolled: 'Iniciativa tirada',
    quickInitiativePromptDesc: 'Tirar iniciativa para:',
    quickInitiativeForAll: 'Todos',
    quickInitiativeNpcEnemiesOnly: 'Solo NPC y enemigos',
    dotApplied: 'Daño periódico aplicado:',
    damagePoints: 'daño',
    statusExpired: 'Estado expirado:',
    charactersExported: 'personajes exportados',
    charactersImported: 'personajes importados',
    noCharactersToExport: 'No hay personajes para exportar',

    // Confirm
    confirmReset: '¿Reiniciar el combate?',
    confirmDelete: '¿Eliminar este combatiente?',
    yes: 'Sí',
    no: 'No',

    // Empty state
    noCombatants: 'Sin combatientes',
    addFirst: 'Añade un combatiente para empezar',

    // Misc
    characters: 'Personajes',
    back: 'Atrás',
    backToHome: 'Volver al inicio',
    eventHistory: 'Historial',
    collapseAll: 'Colapsar todos',
    expandAll: 'Expandir todos',
    noEvents: 'Sin eventos registrados',
    battleNotes: 'Notas de batalla',
    battleNotesPlaceholder: 'Apuntes, objetivos, recordatorios...',
    npcPresetsTitle: 'Presets PNJ',
    npcPresetNew: 'Nuevo preset',
    addToBattleShort: 'A batalla',
    npcPresetSaved: 'Preset guardado',
    saveToPresets: 'Guardar en presets',
    presetsList: 'Presets guardados',
    saveFromBattle: 'Guardar como preset desde batalla',
    saveAsPresetShort: 'Guardar preset',
    clearHistory: 'Borrar historial',
    clear: 'Borrar',
    historyCleared: 'Historial borrado',
    turnOf: 'Turno de',
    tookDamage: 'recibe',
    damageText: 'de daño',
    wasHealed: 'es curado',
    hpText: 'PG',
    gainedStatus: 'ahora está',
    lostStatus: 'ya no está',
    wasAdded: 'ha entrado en combate',
    wasRemoved: 'ha sido retirado',
    stabilizedText: 'se ha estabilizado',
    diedText: 'ha muerto',
    koText: 'ha caído inconsciente',
    revivedText: 'ha sido revivido',
    tempHpGained: 'ha obtenido',
    tempHpText: 'PG temporales',
    deathSaveSuccess: 'ha superado una tirada de muerte',
    deathSaveFailure: 'ha fallado una tirada de muerte',
    statusDictionary: {
      'Accecato': { name: 'Cegado', description: 'No ve. Desventaja ataques; ataques contra tienen ventaja.' },
      'Affascinato': { name: 'Hechizado', description: 'No puede atacar ni dañar al que lo hechizó.' },
      'Afferrato': { name: 'Agarrado', description: 'Velocidad 0, sin bonos velocidad.' },
      'Assordato': { name: 'Ensordecido', description: 'No oye. Falla pruebas de oído.' },
      'Avvelenato': { name: 'Envenenado', description: 'Desventaja en ataques y pruebas.' },
      'Concentrazione': { name: 'Concentración', description: 'Mantiene conjuro; daño requiere tirada concentración.' },
      'Esausto': { name: 'Agotamiento', description: 'Niveles 1–6: desventaja a muerte.' },
      'Impaurito': { name: 'Asustado', description: 'Desventaja si ve la fuente; no puede acercarse.' },
      'Incapacitato': { name: 'Incapacitado', description: 'Sin acciones ni reacciones.' },
      'Invisibile': { name: 'Invisible', description: 'No visible. Desventaja contra; ventaja sus ataques.' },
      'Paralizzato': { name: 'Paralizado', description: 'Incapacitado, vel 0. Falla TS Fue/Des. Cuerpo a cuerpo ventaja, crítico 1,5 m.' },
      'Pietrificato': { name: 'Petrificado', description: 'Piedra. Incapacitado, peso x10.' },
      'Privo di sensi': { name: 'Inconsciente', description: 'Incapacitado, derribado. Cuerpo a cuerpo 1,5 m = crítico.' },
      'Prono': { name: 'Derribado', description: 'En suelo. Desventaja distancia; ventaja cuerpo a cuerpo 1,5 m.' },
      'Rallentato': { name: 'Ralentizado', description: 'Velocidad mitad, -2 CA. Una acción o bonus por turno, sin reacción.' },
      'Sanguinante': { name: 'Desangrándose', description: 'Daño cada turno hasta cura o estabilización.' },
      'Sorpreso': { name: 'Sorprendido', description: 'Primera ronda: no moverse, actuar ni reacciones.' },
      'Spaventato': { name: 'Asustado', description: 'Desventaja si ve la fuente; no puede acercarse.' },
      'Stordito': { name: 'Aturdido', description: 'Incapacitado, vel 0. Falla TS Fue/Des. No habla.' },
      'Trattenuto': { name: 'Restringido', description: 'Vel 0. Desventaja ataques; ventaja contra; desventaja TS Des.' },
      'Benedizione': { name: 'Bendición', description: '+1d4 a un ataque o salvación (tira después del dado).' },
      'Eroismo': { name: 'Heroísmo', description: 'Inmune miedo. PG temp cada turno.' },
      'Fretta': { name: 'Prisa', description: 'Velocidad x2, +2 CA, ventaja TS Des, acción extra (limitada).' },
      'Guidare': { name: 'Guía', description: '+1d4 a una prueba (tira después del dado).' },
      'Protezione': { name: 'Protección', description: 'Reacción: desventaja ataque a aliado adyacente o +1d4 salvación aliado.' },
      'Rigenerazione': { name: 'Regeneración', description: 'Recupera PG cada turno (ej. 10).' },
      'Scudo': { name: 'Escudo', description: 'Reacción: +5 CA contra un ataque hasta próximo turno.' },
      'Volare': { name: 'Volar', description: 'Puede volar. Velocidad de vuelo según efecto.' },
      'Altro...': { name: 'Otro...', description: 'Estado personalizado: nombre y duración.' },
      'Esausto 1': { name: 'Agotamiento 1', description: 'Desventaja pruebas' },
      'Esausto 2': { name: 'Agotamiento 2', description: 'Velocidad mitad' },
      'Esausto 3': { name: 'Agotamiento 3', description: 'Desventaja ataques y salvaciones' },
      'Esausto 4': { name: 'Agotamiento 4', description: 'PG máx mitad' },
      'Esausto 5': { name: 'Agotamiento 5', description: 'Velocidad 0' },
      'Esausto 6': { name: 'Agotamiento 6', description: 'Muerte' },
    },
    exhaustionEffects: {
      1: 'Desventaja en pruebas de característica',
      2: 'Velocidad reducida a la mitad',
      3: 'Desventaja en tiradas de ataque y salvaciones',
      4: 'PG máximos reducidos a la mitad',
      5: 'Velocidad 0',
      6: 'Muerte',
    },
    exhaustionLevelTitle: 'Nivel de agotamiento',
    exhaustionLevelPrefix: 'Nivel ',
    customStatusTitle: 'Estado personalizado',
    customStatusPlaceholder: 'Nombre del estado...',
    statusRegenPerTurn: 'PG por turno',
    statusBleedPerTurn: 'Daño por turno',
  },
  fr: {
    language: 'Langue',
    round: 'Round',
    combat: 'Combat',
    selectMode: 'Choisir le mode',
    selectModeDesc: 'Choisissez le mode qui vous convient et commencez à suivre le combat',
    personalTracking: 'Je suis un joueur',
    personalHubTitle: 'Hub du Joueur',
    personalTrackingDesc: 'Créez des personnages, gérez PV et initiative et combattez en solo ou en groupe',
    masterMode: 'Mode Maître',
    masterModeDesc: 'Créer une partie multijoueur',
    masterModeDescLong: 'Vous êtes le Maître du Donjon ? Créez une partie, partagez le code avec les joueurs et gérez l\'initiative, les PV et les tours pour tous en temps réel.',
    masterOffline: 'Je suis un maître',
    masterOfflineDesc: 'Gérez les combats sur la table : initiative, tours et PV. Préparez la session avec PNJ et notes, puis entrez en bataille.',
    masterHubTitle: 'Hub du Maître',
    masterHubDesc: 'Choisissez comment vous préparer ou entrer en bataille.',
    sessionPrep: 'Préparation de session',
    sessionPrepDesc: 'Organisez des sessions nommées : notes, chronologie et lieux avec rencontres, dialogues, objets, personnages et missions par lieu.',
    sessionPrepDescLong: 'Sessions nommées : notes, chronologie et lieux (rencontres, dialogues, objets, missions). Enregistrez et rouvrez quand il faut.',
    sessionPrepEditorDesc: 'En haut : notes et chronologie. En dessous : lieux. Dans chaque lieu ajoutez rencontres, dialogues, objets, personnages, missions et listes. Nom + Enregistrer.',
    noSavedSessions: 'Aucune session enregistrée. Cliquez "Nouvelle session" (nom, notes, lieux). Enregistrez pour retrouver plus tard.',
    noPlaces: 'Aucun lieu. Cliquez "Ajouter un lieu" et remplissez rencontres, dialogues, objets, personnages et missions.',
    coinPouchTitle: 'Bourse',
    coinPouchButton: 'Portefeuille',
    coinPouchCurrent: 'Solde actuel',
    coinPouchTotalCopper: 'Total en cuivre',
    coinPouchAdd: 'Ajouter des pièces',
    coinPouchAddButton: 'Ajouter',
    coinPouchSpend: 'Dépenser des pièces',
    coinPouchSpendEquivalent: 'Équivalent',
    coinPouchSpendButton: 'Dépenser',
    coinPouchInsufficient: 'Solde insuffisant.',
    coinPouchEnterAmount: 'Saisissez le montant à dépenser.',
    coinPouchSpent: 'Dépense appliquée.',
    coinPlatino: 'MP',
    coinOro: 'MO',
    coinElettro: 'ME',
    coinArgento: 'MA',
    coinRame: 'MR',
    coinPouchEmptyAll: 'Tout vider',
    coinPouchEmptyConfirmTitle: 'Vider la bourse ?',
    coinPouchEmptyConfirmDesc: 'Solde à zéro. Action irréversible.',
    coinPouchEmptyConfirmButton: 'Tout vider',
    manageNpcEnemies: 'Gérer PNJ/Ennemis',
    manageNpcDesc: 'Créez et modifiez des presets pour PNJ, ennemis et compagnons : PV, CA, initiative et notes pour les utiliser rapidement en bataille.',
    manageNpcDescLong: 'Presets PNJ, ennemis, compagnons : nom, PV, CA, bonus initiative, vitesse, notes. Ajoutez en bataille en un clic.',
    npcPresetsEmpty: 'Aucun preset. Cliquez "Nouveau preset" : nom, PV, CA, bonus initiative, type, notes. Puis utilisez-les en bataille.',
    joinLobby: 'Rejoindre une partie',
    joinLobbyDesc: 'Rejoindre une partie existante',
    joinLobbyDescLong: 'Entrez le code du MJ pour rejoindre et suivre le combat en temps réel.',
    multiplayer: 'Multijoueur',
    multiplayerBeta: 'Beta',
    inDevelopment: 'En développement',
    comingSoon: 'Bientôt disponible',
    installAppTitle: 'Installer le site comme application',
    installAppStep1: 'Chrome/Edge : icône (⊕) dans la barre d\'adresse ou Menu → Installer CoCo.',
    installAppStep2: 'Safari (Mac) : Fichier → Ajouter au Dock.',
    installAppStep3: 'Firefox : menu (≡) → Installer.',
    installAppStepIos: 'Sur iPhone/iPad : dans Safari appuie sur Partager (icône flèche vers le haut) en bas ou en haut, puis « Sur l’écran d’accueil ».',
    installAppStepAndroid: 'Sur Android : dans Chrome appuie sur Menu (⋮) en haut à droite et choisis « Ajouter à l’écran d’accueil » ou « Installer l’application ».',
    installAppDontShow: 'Ne plus afficher',
    installAppNotNow: 'Pas maintenant',
    installAppLetsGo: 'C\'est parti !',
    installAppHint: 'Installer CoCo en application',
    multiplayer: 'Multijoueur',
    multiplayerDesc: 'Créez une partie ou rejoignez avec un code pour jouer en ligne',
    charactersHomeDesc: 'Créez ou supprimez vos personnages',
    ariaThemeAccent: 'Thème et accent',
    themeLabel: 'Thème',
    accentLabel: 'Accent',
    themeLight: 'Clair',
    themeDark: 'Sombre',
    close: 'Fermer',
    remove: 'Retirer',
    unpin: 'Dépincer',
    pinInitiative: 'Épingler en haut',
    supportKofi: 'Soutenir le projet sur Ko-fi',
    kofiHideBanner: 'Masquer la bannière',
    kofiShowBanner: 'Afficher le soutien Ko-fi',
    footerSupportText: 'CoCo est sans pub et gratuit (mais pas pour moi 😔), donc si tu veux :',
    footerMadeWithLove: 'Made with love in 2026 by TakaDev 💛',
    privacyPolicy: 'Confidentialité',
    privacyTitle: 'Politique de confidentialité',
    privacyMetaDescription: 'Politique de confidentialité de CoCo (Combat Companion) : données traitées, stockage local, multijoueur et services tiers.',
    privacyLastUpdated: 'Dernière mise à jour : 28 juin 2026',
    privacyIntro: 'CoCo (Combat Companion) est une web app pour gérer les combats D&D 5e, disponible sur combatco.app et en application installable (PWA/TWA). Cette politique décrit le traitement des données personnelles conformément au RGPD.',
    backToHome: 'Retour à l\'accueil',
    privacySections: [
      {
        title: '1. Responsable du traitement',
        body: 'Le responsable est TakaDev, développeur de CoCo (Combat Companion).\nPour toute demande relative à la vie privée : https://combatco.app.',
      },
      {
        title: '2. Données traitées',
        body: 'CoCo ne nécessite pas d\'inscription ni de compte. Les données pouvant être traitées incluent :\n• Données saisies volontairement (noms, notes, combat, préparation), stockées surtout sur l\'appareil.\n• Données techniques anonymes ou agrégées via Vercel Analytics.\n• En multijoueur : identifiants PeerJS et données échangées en temps réel.\n• Préférences (langue, thème, accent) stockées localement.',
      },
      {
        title: '3. Finalités et base légale',
        body: 'Nous traitons les données pour fournir les fonctionnalités, améliorer le service et respecter les obligations légales. Bases : exécution du service (RGPD art. 6.1.b), intérêt légitime (art. 6.1.f) et consentement le cas échéant.',
      },
      {
        title: '4. Stockage sur l\'appareil',
        body: 'La plupart des données de jeu sont en localStorage. Tu peux les supprimer en effaçant les données du site ou en désinstallant l\'app. Nous ne conservons pas durablement le contenu hors ligne sur nos serveurs.',
      },
      {
        title: '5. Mode multijoueur',
        body: 'Le multijoueur utilise PeerJS en peer-to-peer. Les données circulent entre appareils connectés et ne sont pas archivées sur un serveur CoCo. Les serveurs de signalisation PeerJS peuvent traiter des métadonnées de connexion.',
      },
      {
        title: '6. Services tiers',
        body: 'L\'app peut intégrer Vercel Analytics, Google Fonts, Ko-fi, PeerJS et Google Play (TWA Android). Chaque fournisseur applique sa propre politique de confidentialité.',
      },
      {
        title: '7. Tes droits',
        body: 'Tu disposes des droits d\'accès, rectification, effacement, limitation, opposition et portabilité le cas échéant. Tu peux saisir l\'autorité de protection des données de ton pays.',
      },
      {
        title: '8. Mineurs',
        body: 'Nous ne collectons pas sciemment de données personnelles d\'enfants de moins de 16 ans sans consentement parental.',
      },
      {
        title: '9. Modifications',
        body: 'Nous pouvons mettre à jour cette politique. La date de dernière mise à jour figure en haut de page.',
      },
    ],
    homeAppIntro: 'CoCo est un combat tracker D&D 5e : gère initiative, tours, points de vie (PV), états, notes et préparation de session rapidement et clairement pour MJ et joueurs.',
    howItWorksCta: 'Comment fonctionne CoCo ?',
    guideShort: 'Guide',
    howItWorksTitle: 'Comment fonctionne CoCo',
    howItWorksIntro: 'Guide rapide de CoCo pour l\'initiative D&D 5e et la gestion de combat : découvre le suivi des tours, PV, états et outils MJ simplement.',
    howItWorksInitiativeTitle: '1) Tracker initiative D&D 5e',
    howItWorksInitiativeBody: 'Suis l\'ordre d\'initiative, le tour actif et le round de combat en quelques gestes. Parfait pour garder le rythme sans perdre d\'infos.',
    howItWorksHpTitle: '2) Gestion PV, états et ressources',
    howItWorksHpBody: 'Mets à jour rapidement points de vie (PV), KO, conditions, emplacements de sorts et ressources de tour pour personnages et PNJ dans une vue claire.',
    howItWorksPrepTitle: '3) Outils MJ pour préparation de session',
    howItWorksPrepBody: 'Organise lieux, notes, personnages, dialogues, objets et missions avant la session. En jeu, tout est prêt dans un seul outil.',
    enterBattleDesc: 'Lobby et combat en temps réel',
    inBattle: 'en combat',
    nextRound: 'Round suivant',
    combatants: 'combattants',
    addPreset: 'Nouveau preset',
    notes: 'Notes',
    notesPlaceholder: 'Traits, capacités, description...',
    sessionPrepPlaces: 'Lieux',
    addPlace: 'Ajouter un lieu',
    pasteFullCode: 'Colle le lien ou le code reçu du Maître',
    invalidCode: 'Code de lobby invalide',
    heart: 'Cœur',
    toggleKo: 'Basculer K.O.',
    characterFormDesc: 'Formulaire personnage',
    combatantFormDesc: 'Formulaire combattant',
    nameExample: 'Ex. : {name}',
    sessionPrepNotes: 'Notes',
    sessionPrepTimeline: 'Chronologie',
    addNote: 'Ajouter une note...',
    addEvent: 'Ajouter un événement...',
    sessionPrepDialogues: 'Dialogues',
    sessionPrepEncounters: 'Rencontres',
    sessionPrepObjects: 'Objets',
    sessionPrepCharacters: 'Personnages',
    sessionPrepMissions: 'Missions',
    addDialogue: 'Ajouter un dialogue...',
    addEncounter: 'Ajouter une rencontre...',
    addObject: 'Ajouter un objet...',
    addMission: 'Ajouter une mission...',
    addChecklistItem: 'Ajouter un élément...',
    checklist: 'Liste',
    empty: 'Vide',
    newSession: 'Nouvelle session',
    newPlace: 'Nouveau lieu',
    savedSessions: 'Sessions enregistrées',
    sessionNamePlaceholder: 'Nom de la session',
    sessionUnnamed: 'Session sans nom',
    unnamedPlace: 'Sans nom',
    open: 'Ouvrir',
    saved: 'Enregistré',
    deleted: 'Supprimé',
    deleteSessionConfirm: 'Supprimer cette session ?',
    deletePresetConfirm: 'Supprimer ce preset ?',
    addAll: 'Tout ajouter',
    selectCharacters: 'Choisir les personnages',
    selectMultiple: 'Vous pouvez sélectionner plusieurs personnages',
    selectedCount: 'Sélectionnés',
    clearSelection: 'Tout désélectionner',
    noCharacterSelected: 'Aucun personnage sélectionné',
    charactersAdded: 'personnages ajoutés',
    noCharacters: 'Aucun personnage',
    createFirstCharacter: 'Créez le premier personnage',
    addCharacter: 'Nouveau personnage',
    addCharacterFromListDesc: 'Choisissez un personnage dans Personnages',
    editCharacter: 'Modifier le personnage',
    characterSaved: 'Personnage enregistré',
    characterUpdated: 'Personnage mis à jour',
    characterDeleted: 'Personnage supprimé',
    characterDuplicated: 'Personnage dupliqué',
    addedToCombat: 'ajouté au combat',
    alreadyInBattle: 'déjà en combat',
    goToCombat: 'Aller au combat',
    enterBattle: 'Entrer en bataille',
    fightWith: 'Combattre avec',
    selected: 'sélectionnés',
    deselect: 'Désélectionner',
    selectAll: 'Tout sélectionner',
    charactersSelected: 'personnages sélectionnés',
    xp: 'XP',
    xpTotal: 'XP total',
    addXp: 'Ajouter l\'XP gagnée',
    addXpAction: 'Ajouter XP',
    editTotalXp: 'Modifier l\'XP totale',
    xpGained: 'XP ajoutée',
    xpTotalUpdated: 'XP total mise à jour',
    saveTutorialTitle: 'Sauvegarder les personnages',
    saveTutorialDesc: 'En-tête : importer/exporter en JSON.',
    battleTutorialTitle: 'Entrer en bataille',
    battleTutorialDesc: 'Sélectionnez les personnages (cases) puis « Combattre avec X sélectionnés ».',
    dontShowAgain: 'Ne plus afficher',
    tutorialsDisabled: 'Tutoriels désactivés',
    tutorialTitle: 'Tutoriel',
    tutorialNext: 'Suivant',
    tutorialStart: 'Commencer',
    tutorialSkip: 'Passer',
    tutorialPersonalWelcomeTitle: 'Suivi personnel',
    tutorialPersonalWelcomeContent: 'Gérez personnages et combats en local, sans connexion.',
    tutorialPersonal1Title: '1. Personnages',
    tutorialPersonal1Content: '« Nouveau personnage » pour créer et enregistrer. Réutilisables plus tard.',
    tutorialPersonal2Title: '2. Combat',
    tutorialPersonal2Content: '« Combat » sur un personnage pour l\'ajouter. Vous pouvez en ajouter plusieurs.',
    tutorialPersonal3Title: '3. Tours',
    tutorialPersonal3Content: 'Boutons pour PV, états et tour suivant. Initiative suivie automatiquement.',
    tutorialMasterWelcomeTitle: 'Maître hors ligne',
    tutorialMasterWelcomeContent: 'Combat avec joueurs, PNJ, ennemis et compagnons.',
    tutorialMaster1Title: '1. Types',
    tutorialMaster1Content: 'Joueurs (blanc), PNJ alliés (bleu), Ennemis (rouge), Compagnons (vert).',
    tutorialMaster2Title: '2. Ajouter',
    tutorialMaster2Content: '« Ajouter » → choisir le type. PV/CA des PNJ et ennemis masquables.',
    tutorialMaster3Title: '3. Tours',
    tutorialMaster3Content: 'Initiative en haut. « Tour suivant » pour avancer. Jets de mort pour K.O.',
    tempHp: 'PV Temp',
    tempHpShort: 'Temp',
    addTempHp: 'Ajouter PV Temp',
    createOrResume: 'Créer ou reprendre une partie',
    createNewLobby: 'Créer une partie',
    resumeLobby: 'Reprendre la partie',
    lobbyCode: 'Code de la partie',
    lobbyShareHint: 'Partage le lien ou le QR pour que les joueurs rejoignent',
    codeCopied: 'Code copié',
    linkCopied: 'Lien copié',
    copyLink: 'Copier le lien',
    connectedPlayers: 'Joueurs connectés',
    waitingForPlayers: 'En attente de joueurs...',
    closeLobby: 'Fermer la partie',
    lobbyClosed: 'Partie fermée',
    lobbyResumed: 'Partie reprise',
    fullCodeCopied: 'Le code complet inclut l\'ID du Maître',
    showQR: 'Afficher le QR',
    hideQR: 'Masquer le QR',
    rejoinLobbySavedMaster: 'Partie Maître enregistrée',
    rejoinLobbySavedPlayer: 'Partie Joueur enregistrée',
    rejoinLobbyButton: 'Rejoindre',
    dismissSavedLobby: 'Fermer la partie',
    playerStatus: 'État des joueurs',
    healthy: 'En forme',
    injured: 'Blessé',
    critical: 'Critique',
    down: 'K.O.',
    addNPC: 'Ajouter PNJ/Monstre',
    addQuickCombatant: 'Ajout rapide',
    more: 'autres',
    player: 'Joueur',
    npcAlly: 'PNJ Allié',
    enemyType: 'Ennemi',
    companion: 'Compagnon',
    combatantType: 'Type de combattant',
    concentration: 'Concentration',
    concentrationCheckTitle: 'Jet de sauvegarde de concentration',
    concentrationCheckDesc: 'd20 Constitution : 10+ réussite, moins de 10 échec.',
    concentrationSuccessBtn: 'Réussite',
    concentrationFailureBtn: 'Échec',
    concentrationSuccess: 'Concentration maintenue',
    concentrationLost: 'Concentration perdue',
    advDis: 'Avantage/Désavantage',
    advantage: 'Avantage',
    disadvantage: 'Désavantage',
    normal: 'Normal',
    action: 'Action',
    actionShort: 'Act.',
    bonusAction: 'Action bonus',
    bonusActionShort: 'Bonus',
    reaction: 'Réaction',
    reactionShort: 'Réac.',
    advantageShort: 'Avant.',
    disadvantageShort: 'Désav.',
    actionTooltip: 'Action (reset au prochain tour)',
    bonusActionTooltip: 'Action bonus (reset au prochain tour)',
    reactionTooltip: 'Réaction (reset au prochain round)',
    dash: 'Sprint',
    enemy: 'Ennemi',
    ally: 'Allié',
    isEnemy: 'Est un ennemi',
    hpVisible: 'PV visibles aux joueurs',
    hpHidden: 'PV masqués',
    acVisible: 'CA visible',
    enterLobbyCode: 'Entrez le code de la partie',
    yourName: 'Votre nom',
    continue: 'Continuer',
    selectCharacter: 'Choisir un personnage',
    noSavedCharacters: 'Aucun personnage enregistré',
    joinWithoutCharacter: 'Rejoindre sans personnage',
    connected: 'Connecté !',
    waitingForMaster: 'En attente du Maître...',
    connecting: 'Connexion...',
    leaveLobby: 'Quitter la partie',
    enterWithQRCode: 'Entrer avec QR code',
    orEnterManually: 'Ou saisis le code ci-dessous',
    scanQRCode: 'Scanner le QR code',
    scanQRCodeDesc: 'Scannez le QR du MJ pour remplir le code.',
    qrNoCamera: 'Aucune caméra disponible',
    qrCameraError: 'Impossible de démarrer la caméra',
    qrStartingCamera: 'Démarrage de la caméra...',
    qrCodeScanned: 'Code lu !',
    viewBattlefield: 'Aller au champ de bataille',
    yourCharacters: 'Vos personnages',
    you: 'Vous',
    initiative: 'Initiative',
    initiativeOrder: 'Ordre d\'initiative',
    hp: 'PV',
    ac: 'CA',
    currentTurn: 'Tour actuel',
    shortRest: 'Repos court',
    shortRestZeroDice: '0 = repos sans dépenser les dés de vie',
    longRest: 'Repos long',
    shortRestShort: 'Rep. court',
    longRestShort: 'Rep. long',
    shortRestAll: 'Repos court (tous)',
    longRestAll: 'Repos long (tous)',
    shortRestDone: 'Repos court effectué',
    longRestDone: 'Repos long effectué',
    shortRestAllDone: 'Repos court effectué (tous)',
    longRestAllDone: 'Repos long effectué (tous)',
    shortRestTitle: 'Repos court – Dés de vie',
    shortRestNumDice: 'Nombre de dés',
    shortRestDieType: 'Type de dé',
    shortRestRoll: 'Lancer',
    shortRestApply: 'Appliquer',
    shortRestResult: 'Résultat',
    shortRestRecovered: 'PV récupérés',
    shortRestLog: 'a fait un repos court',
    longRestLog: 'a fait un repos long',
    ko: 'K.O.',
    nextTurn: 'Tour suivant',
    addCombatant: 'Ajouter',
    reset: 'Réinitialiser',
    exportJson: 'Exporter JSON',
    importJson: 'Importer JSON',
    dataMenu: 'Données',
    backupComplete: 'Sauvegarde complète',
    backupCompleteDesc: 'Personnages + combat + paramètres',
    restoreBackup: 'Restaurer la sauvegarde',
    restoreBackupDesc: 'Importer sauvegarde complète (remplace tout)',
    exportCharactersOnly: 'Personnages uniquement (exporter)',
    importCharactersOnly: 'Personnages uniquement (importer)',
    dataMenuCharactersSection: 'Personnages uniquement',
    menu: 'Menu',
    status: 'État',
    modify: 'Modifier',
    duplicate: 'Dupliquer',
    damage: 'Dégâts',
    heal: 'Soins',
    customAmount: 'Valeur',
    apply: 'Appliquer',
    edit: 'Modifier',
    delete: 'Supprimer',
    deathSaves: 'Jets de sauvegarde contre la mort',
    success: 'Succès',
    failure: 'Échec',
    stabilized: 'Stabilisé !',
    backTo1HP: 'Retour à 1 PV',
    dead: 'Mort',
    addCombatantTitle: 'Ajouter un combattant',
    editCombatantTitle: 'Modifier le combattant',
    name: 'Nom',
    namePlaceholder: 'Ex. Gobelin, Guerrier...',
    maxHp: 'PV max',
    currentHp: 'PV actuels',
    initiativeValue: 'Initiative',
    initiativeBonus: 'Bonus d\'initiative',
    speed: 'Vitesse',
    speedMovement: 'Vitesse de déplacement',
    speedUnit: 'm/s',
    hitDice: 'Dés de vie',
    hitDiceTotal: 'Nombre de dés',
    hitDiceSides: 'Type de dé',
    hitDiceAvailable: 'Dés disponibles',
    spellSlots: 'Emplacements de sorts',
    statuses: 'États',
    addStatus: 'Ajouter un état',
    statusName: 'Nom de l\'état',
    statusDuration: 'Durée (rounds)',
    dotLabel: 'Dégâts par tour',
    dotDamage: 'Dégâts',
    dotDuration: 'Durée (tours)',
    optional: 'optionnel',
    famiglio: 'Familier',
    famiglioOf: 'Familier de',
    famiglioOfPlaceholder: 'Sélectionner un personnage',
    searchCharacter: 'Rechercher un personnage...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    statusPresets: [
      'Empoisonné', 'Étourdi', 'Aveuglé', 'Paralysé',
      'Brûlé', 'Gelé', 'Charmé', 'Terrifié',
      'À terre', 'Entravé', 'Invisible', 'Incapacité',
    ],
    combatantAdded: 'Combattant ajouté',
    combatantUpdated: 'Combattant mis à jour',
    combatantDeleted: 'Combattant supprimé',
    combatReset: 'Combat réinitialisé',
    dataExported: 'Données exportées',
    dataImported: 'Données importées',
    importError: 'Erreur d\'importation',
    turnChanged: 'Tour de',
    quickInitiative: 'Initiative rapide',
    initiativeRolled: 'Initiative lancée',
    quickInitiativePromptDesc: 'Lancer l\'initiative pour :',
    quickInitiativeForAll: 'Tout le monde',
    quickInitiativeNpcEnemiesOnly: 'PNJ et ennemis uniquement',
    dotApplied: 'Dégâts périodiques appliqués :',
    damagePoints: 'dégâts',
    statusExpired: 'État expiré :',
    charactersExported: 'personnages exportés',
    charactersImported: 'personnages importés',
    noCharactersToExport: 'Aucun personnage à exporter',
    confirmReset: 'Réinitialiser le combat ?',
    confirmDelete: 'Supprimer ce combattant ?',
    yes: 'Oui',
    no: 'Non',
    noCombatants: 'Aucun combattant',
    addFirst: 'Ajoutez un combattant pour commencer',
    characters: 'Personnages',
    back: 'Retour',
    backToHome: 'Retour à l\'accueil',
    eventHistory: 'Historique',
    collapseAll: 'Réduire tout',
    expandAll: 'Développer tout',
    noEvents: 'Aucun événement enregistré',
    battleNotes: 'Notes de bataille',
    battleNotesPlaceholder: 'Notes, objectifs, rappels...',
    npcPresetsTitle: 'Presets PNJ',
    npcPresetNew: 'Nouveau preset',
    addToBattleShort: 'En bataille',
    npcPresetSaved: 'Preset enregistré',
    saveToPresets: 'Enregistrer dans les presets',
    presetsList: 'Presets enregistrés',
    saveFromBattle: 'Enregistrer comme preset depuis la bataille',
    saveAsPresetShort: 'Enregistrer preset',
    clearHistory: 'Effacer l\'historique',
    clear: 'Effacer',
    historyCleared: 'Historique effacé',
    turnOf: 'Tour de',
    tookDamage: 'a subi',
    damageText: 'dégâts',
    wasHealed: 'a été soigné de',
    hpText: 'PV',
    gainedStatus: 'est maintenant',
    lostStatus: 'n\'est plus',
    wasAdded: 'a rejoint le combat',
    wasRemoved: 'a été retiré',
    stabilizedText: 's\'est stabilisé',
    diedText: 'est mort',
    koText: 'est tombé K.O.',
    revivedText: 'a été ranimé',
    tempHpGained: 'a gagné',
    tempHpText: 'PV temporaires',
    deathSaveSuccess: 'a réussi un jet de mort',
    deathSaveFailure: 'a échoué un jet de mort',
    statusDictionary: {
      'Accecato': { name: 'Aveuglé', description: 'Ne voit pas. Désavantage attaques; attaques contre ont avantage.' },
      'Affascinato': { name: 'Charmé', description: 'Ne peut attaquer ni cibler le charmeur.' },
      'Afferrato': { name: 'Agrippé', description: 'Vitesse 0, pas de bonus vitesse.' },
      'Assordato': { name: 'Sourd', description: 'Ne peut entendre. Échoue tests d\'ouïe.' },
      'Avvelenato': { name: 'Empoisonné', description: 'Désavantage attaques et tests.' },
      'Concentrazione': { name: 'Concentration', description: 'Maintient sort; dégâts déclenchent jet concentration.' },
      'Esausto': { name: 'Épuisement', description: 'Niveaux 1–6: désavantage à mort.' },
      'Impaurito': { name: 'Terrifié', description: 'Désavantage en voyant la source; ne peut s\'approcher.' },
      'Incapacitato': { name: 'Incapacité', description: 'Pas d\'actions ni réactions.' },
      'Invisibile': { name: 'Invisible', description: 'Invisible. Désavantage contre; avantage à ses attaques.' },
      'Paralizzato': { name: 'Paralysé', description: 'Incapacité, vit 0. Échoue TS For/Dex. Corps à corps avantage, critique 1,5 m.' },
      'Pietrificato': { name: 'Pétrifié', description: 'Pierre. Incapacité, poids x10.' },
      'Privo di sensi': { name: 'Inconscient', description: 'Incapacité, à terre. Corps à corps 1,5 m = critique.' },
      'Prono': { name: 'À terre', description: 'Au sol. Désavantage à distance; avantage corps à corps 1,5 m.' },
      'Rallentato': { name: 'Ralenti', description: 'Vitesse moitié, -2 CA. Une action ou bonus par tour, pas de réaction.' },
      'Sanguinante': { name: 'Saignant', description: 'Dégâts chaque tour jusqu\'à guérison ou stabilisation.' },
      'Sorpreso': { name: 'Surpris', description: 'Premier round: pas de déplacement, action ni réaction.' },
      'Spaventato': { name: 'Terrifié', description: 'Désavantage en voyant la source; ne peut s\'approcher.' },
      'Stordito': { name: 'Étourdi', description: 'Incapacité, vit 0. Échoue TS For/Dex. Ne parle pas.' },
      'Trattenuto': { name: 'Entravé', description: 'Vit 0. Désavantage attaques; avantage contre; désavantage TS Dex.' },
      'Benedizione': { name: 'Bénédiction', description: '+1d4 à un jet d\'attaque ou sauvegarde (lancer après le dé).' },
      'Eroismo': { name: 'Héroïsme', description: 'Immunité peur. PV temp chaque tour.' },
      'Fretta': { name: 'Hâte', description: 'Vitesse x2, +2 CA, avantage TS Dex, action extra (limitée).' },
      'Guidare': { name: 'Guidance', description: '+1d4 à un test (lancer après le dé).' },
      'Protezione': { name: 'Protection', description: 'Réaction: désavantage attaque sur allié adjacent ou +1d4 sauvegarde allié.' },
      'Rigenerazione': { name: 'Régénération', description: 'Récupère PV chaque tour (ex. 10).' },
      'Scudo': { name: 'Bouclier', description: 'Réaction: +5 CA contre une attaque jusqu\'au prochain tour.' },
      'Volare': { name: 'Vol', description: 'Peut voler. Vitesse de vol selon l\'effet.' },
      'Altro...': { name: 'Autre...', description: 'État personnalisé: nom et durée.' },
      'Esausto 1': { name: 'Épuisement 1', description: 'Désavantage tests' },
      'Esausto 2': { name: 'Épuisement 2', description: 'Vitesse moitié' },
      'Esausto 3': { name: 'Épuisement 3', description: 'Désavantage attaques et TS' },
      'Esausto 4': { name: 'Épuisement 4', description: 'PV max moitié' },
      'Esausto 5': { name: 'Épuisement 5', description: 'Vitesse 0' },
      'Esausto 6': { name: 'Épuisement 6', description: 'Mort' },
    },
    exhaustionEffects: {
      1: 'Désavantage aux tests de caractéristique',
      2: 'Vitesse réduite de moitié',
      3: 'Désavantage aux attaques et jets de sauvegarde',
      4: 'PV maximum réduits de moitié',
      5: 'Vitesse à 0',
      6: 'Mort',
    },
    exhaustionLevelTitle: 'Niveau d\'épuisement',
    exhaustionLevelPrefix: 'Niveau ',
    customStatusTitle: 'État personnalisé',
    customStatusPlaceholder: 'Nom de l\'état...',
    statusRegenPerTurn: 'PV par tour',
    statusBleedPerTurn: 'Dégâts par tour',
  },
};

export const getStatusClass = (statusName) => {
  const name = statusName.toLowerCase();
  if (name.includes('poison') || name.includes('veleno') || name.includes('venen') || name.includes('empoison')) return 'status-poison';
  if (name.includes('stun') || name.includes('stordit') || name.includes('aturd') || name.includes('étourdi')) return 'status-stun';
  if (name.includes('blind') || name.includes('accecat') || name.includes('ceg') || name.includes('aveugl')) return 'status-blind';
  if (name.includes('paralyz') || name.includes('paralizz') || name.includes('paraliz')) return 'status-paralyze';
  if (name.includes('burn') || name.includes('bruciat') || name.includes('quem') || name.includes('brûl')) return 'status-burn';
  if (name.includes('freez') || name.includes('congelat') || name.includes('frozen') || name.includes('congel') || name.includes('gelé')) return 'status-freeze';
  if (name.includes('charm') || name.includes('affascinat') || name.includes('hechiz') || name.includes('encant')) return 'status-charm';
  if (name.includes('fear') || name.includes('spaventat') || name.includes('frightened') || name.includes('mied') || name.includes('asust') || name.includes('terrif')) return 'status-fear';
  return 'status-default';
};
